import React, { useState, useEffect, useRef, useCallback } from "react";
import { DEFAULT_PAGE_DESCRIPTIONS, DEFAULT_SCHEDULER_TAB, DEFAULT_TABS, glossary, OUTPUTS_THAT_GIVE_RESULTS, TEMPLATE_APP, TEMPLATE_APP_ACCOUNTING, TEMPLATE_APP_CHART_OF_ACCOUNTS, TEMPLATE_APP_OUTPUT, TEMPLATE_APP_PERMISSION, TEMPLATE_APP_SOURCE_DATA_TABLES, TEMPLATE_APP_TEAM, TEMPLATE_APP_USE_CASE } from "./Constants";
import { setCurrentAppId, setTemplateId } from "../../store/userAuthSlice";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import SideNav from "./SideNav";
import HomeSideNav from "src/Home/SideNav";
import {
  AppLayout,
  Button,
  ColumnLayout,
  Input,
  Icon,
  Textarea,
  Container,
  Header,
  Box,
  Grid,
  SpaceBetween,
  Link,
  ExpandableSection,
  ContentLayout,
  Table,
  Modal,
  Spinner,
  Badge,
  StatusIndicator,
  HelpPanel,
  Flashbar,
  Alert,
  Tabs,
  FileUpload,
  ButtonDropdown,
  ToggleButton,
} from "@amzn/awsui-components-react";
import AddToCPModal from "src/Home/ClosePortal/components/AddToCPModal";
import {
  ExcelExportParams, ExcelStyle,
  GetContextMenuItemsParams,
  GetRowIdParams,
  GridReadyEvent,
  MenuItemDef
} from 'ag-grid-community';
import "../../index.scss";
import "./template.scss";

import { useSelector, useDispatch } from "react-redux";
import { selectIsEffectiveSupportAdmin } from 'src/utilities/adminUtils';

import { useHistory, useParams, useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';

import favLogo from '../../images/star-regular-brown-for-home.svg'
import favLogoSolid from '../../images/star-solid-brown-for-home.svg'
import { favorite, checkIsFavorite } from '../../utilities/Favorites'
import { featured, checkIsFeatured } from '../../utilities/Featured'

import CustomSelect from "./components/CustomSelect";
import CustomMultiSelect from "./components/CustomMultiSelect";
import CustomInput from "./components/CustomInput";
import CustomMultiInput from "./components/CustomMultiInput";
import CustomSingleInput from "./components/CustomSingleInput";
import CustomMultiHybridInputsForAppOutputs from "./components/CustomMultiHybridInputsForAppOutputs"
import { getEditableFields } from "./Utils/FormMetadata";
import { canAddEditDeleteApplication } from "./Utils/Permissions";
import { addApp, updateApp, deleteAppWithApproval, getSubLinks, getApprovalsForApp, getProcessForAppId, getProcessForAppIdPromise, createAuditLog, getQSDashboardEmbedLinksSync } from "./Utils/AppActivityUtils"
import { useSuggestedLogins, useDirectReports } from "src/hooks/useSuggestedLogins";
import { tancAssociationStatus, listPreference, createPreference, updatePreference } from "../../utilities/AppSyncPlusAPIs"
import { v4 as uuidv4 } from 'uuid';
import CustomMultiHybridInputsForSourceTables from "./components/CustomMultiHybridInputsForSourceTables";
import CustomMultiHybridInputsWithPK from "./components/CustomMultiHybridInputsWithPK";
import CustomMultiHybridInputAndSelect from "./components/CustomMultiHybridInputAndSelect"
import { TEMPLATES, APPS_WITH_APP_LEVEL_PERMISSIONS_IN_TEMPLATE, TEMPLATE_MAPPLE_MAIN_TAB_IDS, TEMPLATE_MAPPLE_PROCESS_TABS_MAPPER, TEMPLATE_MAPPLE_PROCESS_TAB_IDS, LOGICO_TAB_IDS, FLEXICO_TAB_IDS, FRISCO_TAB_IDS } from 'src/Ateam-BI/Templates/Constants';
import {getLogicoProcessesForAppId} from "./Utils/AppActivityUtilsAppsyncPlus"
import Feedback from "src/generic-components/UserFeedback/Feedback";
import { createApprovalDraft, startApproval, startWASApproval } from "src/utilities/ApprovalAPIs";
import { getDataFromMetaByAppId } from "src/utilities/MetaAPIs"
import { loadFlexicoTemplates } from "src/utilities/FlexicoAPIs";
import CustomSelectAlias from "./components/CustomSelectAlias";
import CustomSelectMultiAlias from "./components/CustomSelectMultiAlias";
import { Storage } from 'aws-amplify';
import { configureGenericS3, configurePlusAppsync } from "src/context/AuthContextUtility";
import * as d3 from "d3";
import { AgGridReact } from "ag-grid-react";
import { CellDataType } from "src/utilities/ag-grid-utils";
import MetaComponent from "../META/MetaComponent";
import MenuBar from "./components/MenuBar";
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import AppAuditLogging from '../AuditLogging/AppAuditLogging';
import ApprovalsHome from '../../Approvals/approvalsHome';
import ActionTabsSettingsModal from "./components/ActionTabsSettingsModal";
import { checkIfSupportAdmin } from "../../checkPageAccess";
import { API, graphqlOperation } from 'aws-amplify';
import { getPreference } from 'src/utilities/AppSyncPlusAPIs';
import TilesContainer from "./components/TilesContainer";
import ProcessContentRenderer from "./ProcessContentRenderer";
import ProcessSidebar from "./ProcessSidebar";
import DatasetRefreshSchedule from "../Cruzer/DatasetRefreshSchedule";
import BannerContainer from "../Banners/BannerContainer";
import { BannerDisplayLocation } from "../Banners/BannerTypes";
import DownloadAppModal from "./components/DownloadAppModal";
import { getMissingFields } from "../utils/generalUtils";

// Component ServiceHomepage is a skeleton of a service's homepage using AWS-UI React components.
export default (props) => {
  const dispatch = useDispatch();
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)
  const history = useHistory();
  const location = useLocation();
  const search = useLocation().search
  const searchParams = new URLSearchParams(search)
  const { id: routeId, pid: routePid } = useParams();
  const [NavOpen, setNavOpen] = useState(true);
  const [appNavOpen, setAppNavOpen] = useState(true);
  const [showLoadingIcon, setShowLoadingIcon] = useState(true);
  const userId = useSelector((globalState) => globalState.auth.userId);
  const ln = useLocation()

  //UseCase Details
  const [usecaseName, setUsecaseName] = useState('');
  const [usecaseDescription, setUsecaseDescription] = useState();
  const [usecaseStatus, setUsecaseStatus] = useState();
  const [usecaseComments, setUsecaseComments] = useState();
  const [usecaseDevComments, setUsecaseDevComments] = useState();
  const [usecaseType, setUsecaseType] = useState([]);
  const [usecaseRegions, setUsecaseRegions] = useState([]);
  const [usecaseLedgerImpact, setUsecaseLedgerImpact] = useState([]);
  const [usecaseLaunchMCM, setUsecaseLaunchMCM] = useState('');
  const [usecaseLaunchQQYY, setUsecaseLaunchQQYY] = useState();
  const [financialRelevance, setFinancialRelevance] = useState();
  const [usecaseRunFrequency, setUsecaseRunFrequency] = useState([]);
  const [usecaseMERSavings, setUsecaseMERSavings] = useState();
  const [usecaseMJECount, setUsecaseMJECount] = useState();
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [deleteAppName, setDeleteAppName] = useState('');
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  // Operation Details
  const [usecaseInputSourceTypes, setUsecaseInputSourceTypes] = useState([]);
  const [usecaseDataSourceDetails, setUsecaseDataSourceDetails] = useState([]);
  const [usecaseOutputType, setUsecaseOutputType] = useState([]);
  const [usecaseAutomationTools, setUsecaseAutomationTools] = useState([]);
  const [usecaseARD, setUsecaseARD] = useState();
  const [usecasePDD, setUsecasePDD] = useState();
  const [usecaseTDD, setUsecaseTDD] = useState();
  const [usecaseOutputLink, setUsecaseOutputLink] = useState();

  //Team Details
  const [developerTeam, setDeveloperTeam] = useState();
  const [processOwnerAlias, setProcessOwnerAlias] = useState();
  const [grcControlOwnerAlias, setGrcControlOwnerAlias] = useState();
  const [accountingOrg, setAccountingOrg] = useState();
  const [financialYearImpact, setFinancialYearImpact] = useState();
  const [accountingTeam, setAccountingTeam] = useState();
  const [accountingVP, setAccountingVP] = useState();
  const [accountingTeamEmail, setAccountingTeamEmail] = useState();

  const [toolsOpen, setToolsOpen] = useState(false);

  const [flashBarComments, setFlashBarComments] = useState();
  const [flashBarDevComments, setFlashBarDevComments] = useState();
  const [id, setId] = useState(props?.id);
  const [customSideNavitems, setCustomSideNavitems] = useState(props?.customSideNavitems)
  const [renderJson, setRenderJson] = useState(props?.renderJson)
  const [renderJsonEdited, setRenderJsonEdited] = useState(props?.renderJson)

  const [isFavorite, setIsFavorite] = useState(false);
  const [favDisabled, setFavDisabled] = useState(false);
  const [fieldMetadata, setFieldMetadata] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [shouldNotShowResults, setShouldNotShowResults] = useState(false);
  const [isNewApp, setIsNewApp] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [canDelete, setCanDelete] = useState(false)
  const [canEdit, setCanEdit] = useState(false)
  const [canAdd, setCanAdd] = useState(false)
  const [canDownload, setCanDownload] = useState(false)
  const [enableEditAction, setEnableEditAction] = useState(false)
  const [subLinks, setSubLinks] = useState([])
  const [modalMessage, setModalMessage] = useState('')
  const [subProcesses, setSubProcesses] = useState([])
  const [logicoProcesses, setLogicoProcesses] = useState([])

  const [featuredPressed, setFeaturedPressed] = useState()

  const [updateComments, setUpdateComments] = useState("")
  const [previouslyMissingFields, setPreviouslyMissingFields] = useState([])
  const [modalError, setModalError] = useState("")
  const [alertErrorMessage, setAlertErrorMessage] = useState(null)
  const [flexicoTemplates, setFlexicoTemplates] = useState();
  const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
  const { directReports, directReportsLoading, getDirectReportsCaller } = useDirectReports();
    const [addToCPModalVisible, setAddToCPModalVisible] = useState(false)
  
  // URL encoding/decoding utilities for tab names
  const encodeTabNameForUrl = (tabName) => {
    if (!tabName) return '';
    return encodeURIComponent(tabName);
  };

  const decodeTabNameFromUrl = (encodedName) => {
    if (!encodedName) return '';
    try {
      return decodeURIComponent(encodedName);
    } catch (e) {
      return encodedName;
    }
  };

  // Dynamic tab resolution - maps processType from URL to actual tab ID
  const resolveProcessTypeToTab = (processType, configuration) => {
    if (!processType || !configuration) return null;
    
    const decodedProcessType = decodeTabNameFromUrl(processType);
    
    // Check in action tabs
    const actionTab = configuration.actionTabs?.find(tab => 
      tab.visible && (tab.label === decodedProcessType || tab.id === decodedProcessType)
    );
    if (actionTab) return actionTab.id;
    
    // Check in custom action tabs
    const customTab = configuration.customActionTabs?.find(tab => 
      tab.visible && (tab.label === decodedProcessType || tab.id === decodedProcessType)
    );
    if (customTab) return customTab.id;
    
    // Fallback to static mapper for backward compatibility
    return TEMPLATE_MAPPLE_PROCESS_TABS_MAPPER[decodedProcessType] || null;
  };

  const [activeTabId, setActiveTabId] = useState(searchParams.get("view") && TEMPLATE_MAPPLE_MAIN_TAB_IDS.includes(searchParams.get("view")) ? searchParams.get("view") : "details")
  const [activeSubTabId, setActiveSubTabId] = useState("run") // Will be set properly after config loads
  const [activeReportTabId, setActiveReportTabId] = useState()
  const [quicksightReports, setQuicksightReports] = useState([])
  const [embedUrl, setEmbedUrl] = useState()
  const [embedUrlLoadingMessage, setEmbedUrlLoadingMessage] = useState(null)
  const [annotationInputFile, setAnnotationInputFile] = useState([])
  const [dsInfo, setDsInfo] = useState()
  const [columnsList, setColumnsList] = useState([])
  const gridRef = useRef();
  const [annotationLoader, setAnnotationLoader] = useState(null)
  const [annotationUploadLoader, setAnnotationUploadLoader] = useState(null)
  const [annotationError, setAnnotationError] = useState("error..")
  const [undoEditCount, setUndoEditCount] = useState(0)
  const [selectedRowIndex, setSelectedRowIndex] = useState(0)
  const [showOldValues, setShowOldValues] = useState(0)
  const [multiSelectedRow, setMultiSelectedRow] = useState([])
  const [rowGroupColumns, setRowGroupColumns] = useState([])
  const [showAnnotationImportModal, setShowAnnotationImportModal] = useState(false)
  const [showAnnotationImportAppendModal, setShowAnnotationImportAppendModal] = useState(false)
  const [annotationColumns, setAnnotationColumns] = useState([])
  const [aggregationValues, setAggregationValues] = useState(null)
  const [annotationSaveSuccessMessage, setAnnotationSaveSuccessMessage] = useState(null)
  const [gridInfo, setGridInfo] = useState({ rowCount: 0, totalRows: 0 });
  const annotationFileName = 'annotation.csv'
  const annotationLevel = "public"
  const annotationPrefix = 'annotationv2/'
  const [dataFromMeta, setDataFromMeta] = useState()
  const [awsAccount, setAwsAccount] = useState(null)
  const [selectedProcessUrl, setSelectedProcessUrl] = useState(null)
  const [selectedSidebarContent, setSelectedSidebarContent] = useState(null)
  const [selectedSidebarItemId, setSelectedSidebarItemId] = useState(null)
  const [activeProcessTab, setActiveProcessTab] = useState(searchParams.get("processPage") && TEMPLATE_MAPPLE_PROCESS_TAB_IDS.includes(searchParams.get("processPage")) ? searchParams.get("processPage") : 'history')
  const [highlightedTabs, setHighlightedTabs] = useState([])
  const [isInIframe, setIsInIframe] = useState(false)
  const [showToggleButtons, setShowToggleButtons] = useState(true)
  const [tancStatusCache, setTancStatusCache] = useState({})
  const [friscoProcessTabs, setFriscoProcessTabs] = useState({})
  const [showAddProcessModal, setShowAddProcessModal] = useState(false)
  const [selectedProcessType, setSelectedProcessType] = useState(null)

  // Editable page descriptions (keyed by tab ID)
  const [pageDescriptions, setPageDescriptions] = useState({})
  const [pageDescriptionDraft, setPageDescriptionDraft] = useState("")
  const [editingPageDescriptionTab, setEditingPageDescriptionTab] = useState(null)
  const [pageDescriptionPreferenceId, setPageDescriptionPreferenceId] = useState(null)

  const loadPageDescriptions = () => {
    if (!id || isNewApp) return;

    configurePlusAppsync().then(() => {
      listPreference(
        id,
        'APP',
        'PAGE_DESCRIPTION',
        function onSuccess(response) {
          const preferences = response?.data?.listPreference?.items || [];
          if (preferences.length > 0) {
            const pref = preferences[0];
            setPageDescriptionPreferenceId(pref.preferenceId);
            const information = typeof pref.information === 'string'
              ? JSON.parse(pref.information)
              : pref.information;
            if (information?.descriptions) {
              setPageDescriptions(information.descriptions);
            }
          }
        },
        function onFailure(error) {
          console.error('Error loading page descriptions:', error);
        }
      );
    });
  };

  const savePageDescription = (tabId, newDescription) => {
    const updatedDescriptions = { ...pageDescriptions, [tabId]: newDescription };
    setPageDescriptions(updatedDescriptions);
    setEditingPageDescriptionTab(null);

    const label = `Page Descriptions for ${id}`;
    const information = { descriptions: updatedDescriptions };

    configurePlusAppsync().then(() => {
      if (pageDescriptionPreferenceId) {
        updatePreference(
          pageDescriptionPreferenceId,
          label,
          userId,
          information,
          function onSuccess() {},
          function onFailure(error) { console.error('Error saving page description:', error); }
        );
      } else {
        const newPreferenceId = uuidv4();
        createPreference(
          newPreferenceId,
          'PAGE_DESCRIPTION',
          label,
          id,
          'APP',
          userId,
          information,
          null,
          function onSuccess() { setPageDescriptionPreferenceId(newPreferenceId); },
          function onFailure(error) { console.error('Error creating page description:', error); }
        );
      }
    });
  };

  // Action tabs customization state
  const [actionTabsConfiguration, setActionTabsConfiguration] = useState(null);
  const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)
  const [showActionTabsSettings, setShowActionTabsSettings] = useState(false);
  const [isLoadingActionTabs, setIsLoadingActionTabs] = useState(true);

  const currencyColumns = ['year_1_lc',
    'year_2_lc',
    'year_3_lc',
    'year_4_lc',
    'year_5_lc',
    'thereafter_lc',
    'total_lc',
    'pq_total_commits_lc',
    'pq_accrual_prepaid_lc',
    'pq_ending_total_commits_lc',
    'cq_pmts_lc',
    'expected_commit_lc',
    'diff_lc',
    'pq_accrual_prepaid_usd',
    'pq_ending_total_commits_usd',
    'cq_pmts_usd',
    'change_in_accrual_usd',
    'other_change_usd',
    'fx_usd',
    'cq_commit_usd',
    'check_usd',
    'prev_year_prepaid_accrual_usd',
    'year_1_usd',
    'year_2_usd',
    'year_3_usd',
    'year_4_usd',
    'year_5_usd',
    'thereafter_usd',
    'total_usd',
    'wtd_avg_term_usd',
    'wtd_avg_rate_usd',
    'wtd_avg_term_lc',
    'wtd_avg_rate_lc',
    're_type',
    'aws_non_aws',
    'cq_commencement',
    'cq_amendment',
    'avg_cq_payments',
    'wtd_avg_term_usd_amendment',
    'wtg_avg_rate_usd_amendment'
  ]
  const unEditableColumns = []
  const editableColumns = ['lease_status', 'subgroup']
  const pivotColumns = ['Period - Quarter']
  const validationColumns = ['year_1_lc',
    'year_2_lc',
    'year_3_lc',
    'year_4_lc',
    'year_5_lc',
    'thereafter_lc',
    'total_lc',
    'pq_total_commits_lc',
    'pq_accrual_prepaid_lc',
    'pq_ending_total_commits_lc',
    'cq_pmts_lc',
    'expected_commit_lc',
    'diff_lc',
    'pq_accrual_prepaid_usd',
    'pq_ending_total_commits_usd',
    'cq_pmts_usd',
    'change_in_accrual_usd',
    'other_change_usd',
    'fx_usd',
    'cq_commit_usd',
    'check_usd',
    'prev_year_prepaid_accrual_usd',
    'year_1_usd',
    'year_2_usd',
    'year_3_usd',
    'year_4_usd',
    'year_5_usd',
    'thereafter_usd',
    'total_usd',
    'wtd_avg_term_usd',
    'wtd_avg_rate_usd',
    'wtd_avg_term_lc',
    'wtd_avg_rate_lc',
    're_type',
    'aws_non_aws',
    'cq_commencement',
    'cq_amendment',
    'avg_cq_payments',
    'wtd_avg_term_usd_amendment',
    'wtg_avg_rate_usd_amendment']

  const defaultProjectColDef = {
    resizable: true,
    sortable: true,
    autoHeaderHeight: true,
    filter: true,
    floatingFilter: false,
    filterParams: {
      applyMiniFilterWhileTyping: true
    },
    headerClass: 'header-center',
    editable: true,
    // singleClickEdit: true,
    enableCellChangeFlash: true,
    enableRowGroup: false,
    enableCellChangeFlash: true,
    suppressHeaderMenuButton: true,
    enableHeaderHighlight: true,
    cellSelection: 'single', // or 'multiple'
    suppressCellSelection: false,
    suppressMovable: true,
    cellClassRules: {
      'edited-row': (params) => { return params?.data?.isEdited || params?.data?.isNew },
      'new-row': (params) => { return params?.data?.isNew },
    }
  };

  const sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      }
    ],
    // Hide sidebar by default
    defaultToolPanel: '', // empty string means closed
    // or use 'false' to hide completely
    // defaultToolPanel: false,
  };

      useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${location.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.ACCOUNTING_CENTRAL_APP);

  useEffect(() => {
    // Check if we're inside an iframe
    const checkIframeContext = () => {
      const inIframe = window.self !== window.top;
      setIsInIframe(inIframe);
      setShowToggleButtons(!inIframe);
    };

    checkIframeContext();

    // setInitView()
    return () => {
      document.title = 'Accounting Central'
      // this now gets called when the component unmounts
    };
  }, [routeId, routePid, location.pathname]);

  useEffect(() => {
    gridRef?.current?.api?.refreshCells()
    return () => {
      // this now gets called when the component unmounts
    };
  }, [showOldValues]);

  useEffect(() => {
    validateAnnotationInput()
    return () => {
      // this now gets called when the component unmounts
    };
  }, [annotationInputFile]);

  useEffect(() => {
    document.title = `Accounting Central ${props?.renderJson?.app_name? `- ${props.renderJson.app_name}`: ''}`;
    checkFeatured(id)
    loadPreference()
    return () => {
      // this now gets called when the component unmounts
    };
  }, [id, renderJson]);

  useEffect(() => {
    loadPreference()
  }, [userId, currentStage]);

  useEffect(() => {
    // Load action tabs configuration when app ID changes
    if (id && !isNewApp) {
      loadActionTabsConfiguration();
      loadPageDescriptions();
    }
  }, [id, isNewApp]);



  // Initialize activeSubTabId after configuration loads
  useEffect(() => {
    if (actionTabsConfiguration && !isLoadingActionTabs && searchParams.get("view") === 'actions') {
      const urlProcessType = searchParams.get("processType");
      
      if (urlProcessType) {
        const resolvedTab = resolveProcessTypeToTab(urlProcessType, actionTabsConfiguration);
        
        if (resolvedTab) {
          // Valid tab found, use it
          setActiveSubTabId(resolvedTab);
        } else {
          // Invalid processType, fallback to actions tab without processType
          setActiveSubTabId('run');
          setSelectedProcessUrl(null);
          setSelectedSidebarItemId(null);
          setSelectedSidebarContent(null);
          searchParams.delete("processType");
          searchParams.delete("processId");
          searchParams.delete("processPage");
          history.replace({
            ...history.location.search,
            search: `${searchParams.toString()}`,
          });
        }
      } else {
        // No processType but on actions tab, set default
        setActiveSubTabId('run');
      }
    }
  }, [actionTabsConfiguration, isLoadingActionTabs]);


  useEffect(() => {
    getEmbedUrl()
  }, [activeReportTabId]);

  useEffect(() => {
    if (activeTabId == 'results') {
      getEmbedUrl()
    }
    
  }, [activeTabId]);

  useEffect(() => {

    if (activeTabId === 'actions') {
      setShowLoadingIcon(true)
      if (activeSubTabId === 'run' && (flexicoTemplates && flexicoTemplates?.length > 0)) {
          if(searchParams.get("processId")) {
            const template = flexicoTemplates?.find((template) => template?.flex_id === searchParams.get("processId"))
            if(template) {
              setSelectedSidebarItemId(template.flex_id)

              const flexicoTabs = [
                { label: 'Execute', action: () => { setSelectedProcessUrl(`/App/${id}/flexico/${template.flex_id}/upload`); setActiveProcessTab('execute'); 
                const params = new URLSearchParams(location.search);
                params.set('processId', template.flex_id);
                params.set('processPage', 'execute'); 
                history.replace({ ...history.location, search: params.toString() }); } },
                { label: 'History', action: () => { setSelectedProcessUrl(`/App/${id}/flexico/${template.flex_id}/history`); setActiveProcessTab('history'); 
                const params = new URLSearchParams(location.search);
                params.set('processId', template.flex_id);
                params.set('processPage', 'history'); 
                history.replace({ ...history.location, search: params.toString() });} },
                { label: 'Settings', action: () => { setSelectedProcessUrl(`/App/${id}/flexico/${template.flex_id}`); setActiveProcessTab('settings');
                const params = new URLSearchParams(location.search);
                params.set('processId', template.flex_id);
                params.set('processPage', 'settings'); 
                history.replace({ ...history.location, search: params.toString() }); } },
                { label: 'Audit logs', action: () => { setSelectedProcessUrl(`/App/${id}/flexico/${template.flex_id}/FlexicoProcessAuditLogs`); setActiveProcessTab('audit_logs'); 
                const params = new URLSearchParams(location.search);
                params.set('processId', template.flex_id);
                params.set('processPage', 'audit_logs'); 
                history.replace({ ...history.location, search: params.toString() });} }
              ];
              setSelectedSidebarContent(flexicoTabs);
              
              if(searchParams.get("processPage") && FLEXICO_TAB_IDS.includes(searchParams.get("processPage"))) {
                setActiveProcessTab(searchParams.get("processPage"))
                setSelectedProcessUrl(searchParams.get("processPage") === 'history' ? `/App/${id}/flexico/${template.flex_id}/${searchParams.get("processPage")}` : 
                                      searchParams.get("processPage") === 'settings' ? `/App/${id}/flexico/${template.flex_id}` :
                                      searchParams.get("processPage") === 'audit_logs' ? `/App/${id}/flexico/${template.flex_id}/FlexicoProcessAuditLogs` :
                                      `/App/${id}/flexico/${template.flex_id}/upload`)
              } else {
                  setActiveProcessTab("execute")
                  setSelectedProcessUrl(`/App/${id}/flexico/${template.flex_id}/upload`)
                  searchParams.delete('processPage')
                  searchParams.append('processPage', 'execute')
                  history.replace({
                  ...history.location.search,
                  search: `${searchParams.toString()}`,
                })
              }
            } else {
              setSelectedProcessUrl(null);
              setSelectedSidebarItemId(null);
              setSelectedSidebarContent(null);
              searchParams.delete('processId')
              searchParams.delete('processPage')
              history.replace({
                ...history.location.search,
                search: `${searchParams.toString()}`,
              })
              setShowLoadingIcon(false)
              return;
            }
          } 
    } 
    else if (activeSubTabId === 'upload' && (subProcesses && subProcesses?.length > 0)) {

       if(searchParams.get("processId")) {
        const process = subProcesses?.find((process) => process?.process_id == searchParams.get("processId"))
        if(process) {
          setSelectedSidebarItemId(process.process_id)
          
          const defaultFriscoTabs = [
            { label: 'Upload', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/upload`); setActiveProcessTab('upload'); 
              const params = new URLSearchParams(location.search);
              params.set('processId', process.process_id);
              params.set('processPage', 'upload'); 
              history.replace({ ...history.location, search: params.toString() }); } },
            { label: 'History', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/history`); setActiveProcessTab('history'); 
              const params = new URLSearchParams(location.search);
              params.set('processId', process.process_id);
              params.set('processPage', 'history'); 
              history.replace({ ...history.location, search: params.toString() }); } },
            { label: 'Settings', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}`); setActiveProcessTab('settings'); 
              const params = new URLSearchParams(location.search);
              params.set('processId', process.process_id);
              params.set('processPage', 'settings'); 
              history.replace({ ...history.location, search: params.toString() });} },
            { label: 'Audit logs', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/FriscoProcessAuditLogs`); setActiveProcessTab('audit_logs')
              const params = new URLSearchParams(location.search);
              params.set('processId', process.process_id);
              params.set('processPage', 'audit_logs'); 
              history.replace({ ...history.location, search: params.toString() }); } }
          ];
          setSelectedSidebarContent(defaultFriscoTabs);
          
          // Async TANC check - will update tabs if needed
          getFriscoTabsForProcess(process.process_id).then(tabsConfig => {
            if (tabsConfig?.hasTANCAssociation) {
              const updatedFriscoTabs = [
                { label: 'Upload', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/upload`); setActiveProcessTab('upload'); 
                const params = new URLSearchParams(location.search);
                params.set('processId', process.process_id);
                params.set('processPage', 'upload'); 
                history.replace({ ...history.location, search: params.toString() });} },
                { label: 'Edit in UI', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/upload?mode=inline_edit`); setActiveProcessTab('inline_edit')
                  const params = new URLSearchParams(location.search);
                  params.set('processId', process.process_id);
                  params.set('processPage', 'inline_edit'); 
                  history.replace({ ...history.location, search: params.toString() }); } },
                { label: 'History', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/history`); setActiveProcessTab('history'); 
                  const params = new URLSearchParams(location.search);
                  params.set('processId', process.process_id);
                  params.set('processPage', 'history'); 
                  history.replace({ ...history.location, search: params.toString() });} },
                { label: 'Settings', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}`); setActiveProcessTab('settings');
                  const params = new URLSearchParams(location.search);
                  params.set('processId', process.process_id);
                  params.set('processPage', 'settings'); 
                  history.replace({ ...history.location, search: params.toString() }); } },
                { label: 'Audit logs', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/FriscoProcessAuditLogs`); setActiveProcessTab('audit_logs'); 
                  const params = new URLSearchParams(location.search);
                  params.set('processId', process.process_id);
                  params.set('processPage', 'audit_logs'); 
                  history.replace({ ...history.location, search: params.toString() });} }
              ];
              setSelectedSidebarContent(updatedFriscoTabs);
            }
          });
          
          if(searchParams.get("processPage") && FRISCO_TAB_IDS.includes(searchParams.get("processPage"))) {
            setActiveProcessTab(searchParams.get("processPage"))
            setSelectedProcessUrl(searchParams.get("processPage") === 'history' ? `/App/${id}/process/${process.process_id}/history` :
                                  searchParams.get("processPage") === 'settings' ? `/App/${id}/process/${process.process_id}` :
                                  searchParams.get("processPage") === 'audit_logs' ? `/App/${id}/process/${process.process_id}/FriscoProcessAuditLogs` :
                                  searchParams.get("processPage") === 'inline_edit' ? `/App/${id}/process/${process.process_id}/upload?mode=inline_edit` :
                                  `/App/${id}/process/${process.process_id}/upload`)
          } else {
              setActiveProcessTab("upload")
              setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/upload`)
              searchParams.delete('processPage')
              searchParams.append('processPage', 'upload')
              history.replace({
              ...history.location.search,
              search: `${searchParams.toString()}`,
            })
          }
        } else {
          setSelectedProcessUrl(null);
          setSelectedSidebarItemId(null);
          setSelectedSidebarContent(null);
          searchParams.delete('processId')
          searchParams.delete('processPage')
          history.replace({
            ...history.location.search,
            search: `${searchParams.toString()}`,
          })
          setShowLoadingIcon(false)
          return;
        }
      }
    } else if (activeSubTabId === 'categorize' && (logicoProcesses && logicoProcesses?.length > 0)) {
        if(searchParams.get("processId")) {
          const process = logicoProcesses?.find((process) => process?.logico_process_id === searchParams.get("processId"))
          if(process) {
            setSelectedSidebarItemId(process.logico_process_id)
            
            // Set sidebar content for Logico during URL initialization
            
            const logicoTabs = [
              { label: 'Upload', 
                action: () => { setSelectedProcessUrl(`/App/${id}/LogicoProcess/${process.logico_process_id}/upload`); 
                setActiveProcessTab('upload');
                const params = new URLSearchParams(location.search);
                params.set('processId', process.logico_process_id);
                params.set('processPage', 'upload'); 
                history.replace({ ...history.location, search: params.toString() }) } },
              { label: 'History', 
                action: () => { setSelectedProcessUrl(`/App/${id}/LogicoProcess/${process.logico_process_id}/history`); 
                setActiveProcessTab('history'); 
                const params = new URLSearchParams(location.search);
                params.set('processId', process.logico_process_id);
                params.set('processPage', 'history'); 
                history.replace({ ...history.location, search: params.toString() })} },
              { label: 'Settings', 
                action: () => { setSelectedProcessUrl(`/App/${id}/LogicoProcess/${process.logico_process_id}`); 
                setActiveProcessTab('settings'); const params = new URLSearchParams(location.search);
                params.set('processId', process.logico_process_id);
                params.set('processPage', 'settings'); 
                history.replace({ ...history.location, search: params.toString() })} },
              { label: 'Audit logs', 
                action: () => { setSelectedProcessUrl(`/App/${id}/LogicoProcess/${process.logico_process_id}/LogicoProcessAuditLogs`); 
                setActiveProcessTab('audit_logs'); const params = new URLSearchParams(location.search);
                params.set('processId', process.logico_process_id);
                params.set('processPage', 'audit_logs'); 
                history.replace({ ...history.location, search: params.toString() })} }
            ];
            setSelectedSidebarContent(logicoTabs);
            
            if(searchParams.get("processPage") && LOGICO_TAB_IDS.includes(searchParams.get("processPage"))) {
              setActiveProcessTab(searchParams.get("processPage"))
              setSelectedProcessUrl(searchParams.get("processPage") === 'history' ? `/App/${id}/LogicoProcess/${process.logico_process_id}/history` :
                                    searchParams.get("processPage") === 'settings' ? `/App/${id}/LogicoProcess/${process.logico_process_id}` :
                                    `/App/${id}/LogicoProcess/${process.logico_process_id}/upload`)
            } else {
                setActiveProcessTab("upload")
                setSelectedProcessUrl(`/App/${id}/LogicoProcess/${process.logico_process_id}/upload`)
                searchParams.delete('processPage')
                searchParams.append('processPage', 'upload')
                history.replace({
                ...history.location.search,
                search: `${searchParams.toString()}`,
              })
            }
          } else {
            setSelectedProcessUrl(null);
            setSelectedSidebarItemId(null);
            setSelectedSidebarContent(null);
            searchParams.delete('processId')
            searchParams.delete('processPage')
            history.replace({
              ...history.location.search,
              search: `${searchParams.toString()}`,
            })
            setShowLoadingIcon(false)
            return;
          }
        }
      }
    }
    setShowLoadingIcon(false)
  }, [flexicoTemplates, subProcesses, logicoProcesses]);

  const loadPreference = () => {
    if(id && userId){
      checkFavorite(id, userId)
    }
  }

  const handleMenuChange = (mainTab, subTab) => {

    searchParams.delete(`view`)
    searchParams.append(`view`, mainTab)
    searchParams.delete("processType") 
    searchParams.delete('processId')
    searchParams.delete('processPage')
    setActiveTabId(mainTab);
    
    // Clear selected process when switching between main action tabs
    if (mainTab === 'actions') {
      setSelectedProcessUrl(null);
      setSelectedSidebarItemId(null);
      setSelectedSidebarContent(null);
      
      let targetSubTab = subTab;
      
      if (!targetSubTab) {
        const dynamicTabs = getDynamicActionTabs();
        if (dynamicTabs.length > 0) {
          targetSubTab = dynamicTabs[0].id;
        } else {
          targetSubTab = 'run'; // Fallback
        }
      }
      
      setActiveSubTabId(targetSubTab);
      
      // Find the tab label from configuration to use in URL
      if (actionTabsConfiguration) {
        const allTabs = [
          ...(actionTabsConfiguration.actionTabs || []),
          ...(actionTabsConfiguration.customActionTabs || [])
        ];
        const selectedTab = allTabs.find(tab => tab.id === targetSubTab);
        
        if (selectedTab) {
          // Use the tab label (which may have been renamed) and encode it for URL
          const encodedTabName = encodeTabNameForUrl(selectedTab.label);
          searchParams.append("processType", encodedTabName);
        } else {
          // Fallback to static mapper for backward compatibility
          const processType = Object.keys(TEMPLATE_MAPPLE_PROCESS_TABS_MAPPER).find(key => TEMPLATE_MAPPLE_PROCESS_TABS_MAPPER[key] === targetSubTab);
          if (processType) {
            searchParams.append("processType", processType);
          }
        }
      } else {
        // Fallback when configuration not loaded yet
        const processType = Object.keys(TEMPLATE_MAPPLE_PROCESS_TABS_MAPPER).find(key => TEMPLATE_MAPPLE_PROCESS_TABS_MAPPER[key] === targetSubTab);
        if (processType) {
          searchParams.append("processType", processType);
        }
      }
    } else {
      setActiveSubTabId(subTab);
    }
    history.replace({
      ...history.location.search,
      search: `${searchParams.toString()}`,
    })
  };

  // Multi-tab highlighting helper functions
  const updateTabHighlighting = (mainTab, dynamicTab = null, shouldHighlightBoth = false) => {
    if (shouldHighlightBoth && dynamicTab) {
      setHighlightedTabs([mainTab, dynamicTab]);
    } else if (mainTab) {
      setHighlightedTabs([mainTab]);
    } else {
      setHighlightedTabs([]);
    }
  };

  const getActiveTabId = () => {
    // For Frisco items: highlight both Upload and History tabs
    if (selectedSidebarContent && activeSubTabId === 'upload') {
      return 'upload'; // This will be handled by the highlighting logic
    }
    // For other cases, use the current logic
    return selectedSidebarContent ? activeProcessTab : activeSubTabId;
  };

  const isTabHighlighted = (tabId) => {
    if (selectedSidebarContent) {
      // When sidebar content is selected, highlight both main tab and dynamic tab
      return tabId === activeSubTabId || tabId === activeProcessTab;
    }
    return tabId === activeSubTabId;
  };

  useEffect(() => {

    setFlashBarComments([{
      type: "error",
      dismissible: true,
      dismissLabel: "Dismiss message",
      onDismiss: () => setFlashBarComments([]),
      content: (
        <>
          {usecaseComments}
        </>
      ),
      id: "comments"
    }])

  }, [usecaseComments])

  useEffect(() => {
  }, [embedUrl])


  useEffect(() => {
    setFlashBarDevComments([{
      type: "error",
      dismissible: true,
      dismissLabel: "Dismiss message",
      onDismiss: () => setFlashBarDevComments([]),
      content: (
        <>
          {usecaseDevComments}
        </>
      ),
      id: "comments"
    }])

  }, [usecaseDevComments])

  useEffect(() => {
    loadSideNav(subProcesses)
  }, [subProcesses, canEdit, subLinks, logicoProcesses, flexicoTemplates, id, activeSubTabId])

  // Listen for iframe messages to refresh data when new items are created
  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.data && event.data.type === 'REFRESH_PARENT_DATA') {
        // Refresh the data when a new item is created
        loadData();
      }
    };

    window.addEventListener('message', handleIframeMessage);
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [id]);

  useEffect(() => {
    // clean data
    let jsonData = cleanData(props.renderJson)
    setRenderJson(jsonData)
    setRenderJsonEdited(jsonData)
  }, [props.renderJson])


  useEffect(() => {
    setInitView()
    setRenderJsonEdited(renderJson)
  }, [renderJson])

  useEffect(() => {
    checkIfFormIsSubmittable()
    let hasResultsOutput = !!renderJsonEdited[TEMPLATE_APP.OUTPUT]?.find(output => OUTPUTS_THAT_GIVE_RESULTS.has(output[TEMPLATE_APP_OUTPUT.TYPE]))
    setShouldNotShowResults(!hasResultsOutput)
  }, [renderJsonEdited])

  const mandatoryFieldListener = (key, enableUpdate) => {
    mandatoryFieldsMissing[key] = enableUpdate
  }

  const getEmbedUrl = async () => {
    if (activeReportTabId == undefined) {
      return
    }
    setEmbedUrlLoadingMessage("Loading report..")
    let outputs = renderJson[TEMPLATE_APP.OUTPUT].sort((a, b) => a[TEMPLATE_APP_OUTPUT.LABEL].localeCompare(b[TEMPLATE_APP_OUTPUT.LABEL]))

    if (isEditMode) {
      outputs = renderJsonEdited[TEMPLATE_APP.OUTPUT].sort((a, b) => a[TEMPLATE_APP_OUTPUT.LABEL].localeCompare(b[TEMPLATE_APP_OUTPUT.LABEL]))
    }

    let dashboardId = outputs[activeReportTabId][TEMPLATE_APP_OUTPUT.VALUE]
    let region = 'us-east-1'
    let aws_account = outputs[activeReportTabId][TEMPLATE_APP_OUTPUT.AWS_ACCOUNT] || 'FAST'
    setAwsAccount(aws_account)
    if (dashboardId.includes("http")) {
      // its a url, fetch region and id
      let urlSplit = dashboardId?.replace(/\/$/, '').split("/")
      dashboardId = urlSplit[urlSplit?.length - 1]
      if (urlSplit[2].includes("quicksight")) {
        region = urlSplit[2].split(".")[0]
      }
    }
    setEmbedUrl(null)

    let response = await getQSDashboardEmbedLinksSync(aws_account, region, dashboardId)
    setEmbedUrl(response.url)
    setEmbedUrlLoadingMessage(null)
  }
  const setInitView = async () => {
    if (id) {
      setSubLinks(getSubLinks(id))
      dispatch(setCurrentAppId(id));
      loadData();
      setIsEditMode(false)
      setIsNewApp(false)
    } else {
      setIsNewApp(true)
    }
    loadEditableFields();
    let accessPerms;
    if (id && APPS_WITH_APP_LEVEL_PERMISSIONS_IN_TEMPLATE[currentStage?.toUpperCase()].includes(id)) {
      accessPerms = await canAddEditDeleteApplication(userId, id, currentStage)
    }
    else {
      accessPerms = await canAddEditDeleteApplication(userId, TEMPLATES.MAPLE, currentStage)
    }
    setCanDelete(accessPerms?.delete)
    setCanEdit(accessPerms?.edit)
    setCanAdd(accessPerms?.add)
    setCanDownload(accessPerms?.download)
    if (!id && accessPerms?.add) {
      setIsNewApp(true)
      setShowLoadingIcon(false);
      (!isEditMode) ? setIsEditMode(true) : ''
    }

    // !id means isNewApp=true. Sometimes the useeffect take time, so relying on id. id is a path param
    if (!id && !accessPerms?.add) {
      setAlertErrorMessage(
        {
          "header": "Access denied",
          "message": "No access to add an application"
        }
      )
    } else {
      setAlertErrorMessage(null)
    }
  
   
  }

  const loadFrisco = async(app_id) => {
    getProcessForAppId(app_id, function onSuccess(response){
      if (response?.data?.getProcessesForAppIDV2) {
          response.data.getProcessesForAppIDV2?.sort((a, b) => {
            return a?.label.localeCompare(b?.label)
          })
          setSubProcesses(response.data.getProcessesForAppIDV2)
        }
    })        
  }

  const loadLogico = async(app_id) => {
    let response = await getLogicoProcessesForAppId(id)
      if (response?.data?.getLogicoProcessesForAppID) {
        const sorted = response?.data?.getLogicoProcessesForAppID?.sort((a, b) => { return a?.display_label?.localeCompare(b?.display_label) })
        setLogicoProcesses(sorted)
      }
  }

  const loadFlexico = (app_id) => {
    loadFlexicoTemplates(app_id, function onSuccess(result) {
      setFlexicoTemplates(result.data.listFlexicoTemplatesRDS)
    }, function onFailure(error) {

    })
  }

  const loadServices = (app_id) => {
      loadFrisco(app_id)
      loadLogico(app_id)
      loadFlexico(app_id)
  }

  const cleanData = (input) => {
    // some cases, DB responds with null if there is no acc team
    if (input.hasOwnProperty(TEMPLATE_APP.ACCOUNTING_TEAM) && input[TEMPLATE_APP.ACCOUNTING_TEAM] && input[TEMPLATE_APP.ACCOUNTING_TEAM]?.length > 0 && !input[TEMPLATE_APP.ACCOUNTING_TEAM][0][TEMPLATE_APP_TEAM.TEAM]) {
      input[TEMPLATE_APP.ACCOUNTING_TEAM] = null
    }
    return input
  }

  const loadEditableFields = async () => {
    let res = await getEditableFields()
    setFieldMetadata(res)
  }

  const loadSideNav = (subProcesses) => {

    let sideNavSubLinks = []
    subLinks?.forEach((subLink) => {
      sideNavSubLinks.push({
        "type": "link",
        "text": subLink.label,
        "href": subLink.url
      })
    })

    let sideNavLinks = []
    if (id) {
      if (sideNavSubLinks?.length > 0) {
        sideNavLinks = sideNavLinks.concat(sideNavSubLinks)
      }
    }

    if (sideNavLinks?.length > 0) {
      sideNavLinks = sideNavLinks.concat(props?.customSideNavitems)
      setCustomSideNavitems(sideNavLinks)
    }
  }

  const getCurrentTime = () => {
    return Date.now();
  }

  const loadView = () => {
    setUsecaseName(renderJson[TEMPLATE_APP.APP_NAME]);
    setUsecaseDescription(renderJson[TEMPLATE_APP.APP_DESCRIPTION]);
    setUsecaseStatus(renderJson[TEMPLATE_APP.STATUS]);
    setUsecaseComments(renderJson[TEMPLATE_APP.FLASH_INFO_DESCRIPTION]);
    setUsecaseDevComments(renderJson[TEMPLATE_APP.DEV_ALERT_MESSAGES]);
    setUsecaseLedgerImpact(renderJson[TEMPLATE_APP.LEDGER_INFO]);
    setUsecaseLaunchMCM(renderJson[TEMPLATE_APP.LAUNCH_MCM]);
    setUsecaseLaunchQQYY(renderJson[TEMPLATE_APP.LAUNCH_QQ_YY]);
    setUsecaseRunFrequency(renderJson[TEMPLATE_APP.CADENCE]);
    setUsecaseMERSavings(renderJson[TEMPLATE_APP.ANNUAL_MER_SAVINGS]);
    setUsecaseMJECount(renderJson[TEMPLATE_APP.PROCESS_MJE_COUNT]);
    setUsecaseRegions(renderJson[TEMPLATE_APP.REGION]);
    setUsecaseType(renderJson[TEMPLATE_APP.USE_CASE]);
    setUsecaseDataSourceDetails(renderJson[TEMPLATE_APP.DATASOURCE]);
    setUsecaseARD(renderJson[TEMPLATE_APP.ARD]);
    setUsecasePDD(renderJson[TEMPLATE_APP.PDD]);
    setUsecaseTDD(renderJson[TEMPLATE_APP.TDD]);
    setUsecaseInputSourceTypes(
      renderJson[TEMPLATE_APP.INPUT_SOURCE_TYPE]
    );
    setUsecaseOutputType(renderJson[TEMPLATE_APP.OUTPUT]);
    setUsecaseAutomationTools(
      renderJson[TEMPLATE_APP.AUTOMATION_TOOLS]
    );
    setUsecaseOutputLink(renderJson[TEMPLATE_APP.OUTPUT]);

    setDeveloperTeam(renderJson[TEMPLATE_APP.DEVELOPER_TEAM.team]);
    setProcessOwnerAlias(renderJson[TEMPLATE_APP.PROCESS_OWNER]);
    setGrcControlOwnerAlias(renderJson[TEMPLATE_APP.GRC_CONTROL_OWNER]);
    setAccountingOrg(renderJson[TEMPLATE_APP.ORGANIZATION]);
    setFinancialRelevance(renderJson[TEMPLATE_APP.FINANCIAL_RELEVANCE]);
    setFinancialYearImpact(renderJson[TEMPLATE_APP.FINANCIAL_YEAR_IMPACT]);
    setAccountingTeam(renderJson[TEMPLATE_APP.ACCOUNTING_TEAM?.team]);
    setAccountingTeamEmail(renderJson[TEMPLATE_APP.ACCOUNTING_TEAM?.email]);
    setAccountingVP(renderJson[TEMPLATE_APP.VP]);
    setShowLoadingIcon(false);

    fetchEmbedView()
  }

  const loadDataFromMeta = async () => {
    const response = await getDataFromMetaByAppId(id)
    setDataFromMeta(response)
  }

  const loadData = async () => {
    if (!isNewApp && renderJson && Object.keys(renderJson)?.length > 0) {
      setShowLoadingIcon(true);
      if (!searchParams.get("view") || !TEMPLATE_MAPPLE_MAIN_TAB_IDS.includes(searchParams.get("view"))) {
        searchParams.delete("view")
        searchParams.append("view", 'details') 
      }

      if (searchParams.get("view") !== 'actions') {
        setSelectedProcessUrl(null);
        setSelectedSidebarItemId(null);
        setSelectedSidebarContent(null);
          searchParams.delete("processType")
          searchParams.delete("processId")
          searchParams.delete("processPage")
      } else if (searchParams.get("view") === 'actions') {
        // Validate processType using dynamic configuration
        const urlProcessType = searchParams.get("processType");
        
        if (urlProcessType && actionTabsConfiguration) {
          const resolvedTab = resolveProcessTypeToTab(urlProcessType, actionTabsConfiguration);
          
          if (!resolvedTab) {
            // Invalid processType, fallback to actions tab without processType
            setSelectedProcessUrl(null);
            setSelectedSidebarItemId(null);
            setSelectedSidebarContent(null);
            searchParams.delete("processType");
            searchParams.delete("processId");
            searchParams.delete("processPage");
          }
          // If resolvedTab exists, keep the URL as is - it will be handled by the initialization useEffect
        } else if (!urlProcessType) {
          // No processType specified, this is fine - will default to first tab
          setSelectedProcessUrl(null);
          setSelectedSidebarItemId(null);
          setSelectedSidebarContent(null);
          searchParams.delete("processId");
          searchParams.delete("processPage");
        }
      }
      history.replace({
                    ...history.location.search,
                    search: `${searchParams.toString()}`,
                  })
      loadView()
      loadServices(id)
      loadDataFromMeta()
      setShowLoadingIcon(false);
    }
  
  };

  const checkFavorite = (appId, userId) => {
    checkIsFavorite(appId, userId, function onResult(response) {
      setIsFavorite(response)
    })
  }

  const markFavorite = async (appId) => {
    setFavDisabled(true)
    await favorite(appId, userId, function onAdded(result) {
      setIsFavorite(true)
    }, function onDeleted(result) {
      setIsFavorite(false)
    }, function onFailure(result) {
    })
    setFavDisabled(false)
  }

  const checkFeatured = (appId) => {
    checkIsFeatured(appId, function onResult(response) {
      setFeaturedPressed(response)
    })
  }

  const markFeatured = async (appId) => {
    await featured(appId, function onAdded(result) {
      setFeaturedPressed(true)
    }, function onDeleted(result) {
      setFeaturedPressed(false)
    }, function onFailure(result) {
    })
  }

  const isEditable = (fieldName, subKey = null) => {
    if (subKey) {
      return isNewApp || (isEditMode && fieldMetadata && fieldMetadata[fieldName][subKey] && fieldMetadata[fieldName][subKey]['editable'])
    }
    else {
      return isNewApp || (isEditMode && fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName]['editable'])
    }

  }

  const getSelectFieldValues = (fieldName, subKey = null) => {
    if (fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName]['values']) {
      if (fieldName === TEMPLATE_APP.STATUS && (usecaseStatus === 'Active' || usecaseStatus === 'Deprecated') && !isNewApp) {
        const index = fieldMetadata[fieldName]['values'].findIndex((option) => (option.value === 'WIP'))
        fieldMetadata[fieldName]['values'][index]["disabled"] = true
        fieldMetadata[fieldName]['values'][index]["disabledReason"] = 'Cannot update from "Active" or "Deprecated" status to "WIP".'
      } else if (fieldName === TEMPLATE_APP.STATUS && isNewApp) {
        fieldMetadata[fieldName]['values'].forEach((item) => {
          if (item.value === 'Active' || item.value === 'Deprecated') {
            item["disabled"] = true
            item["disabledReason"] = '"Active" and "Deprecated" statuses are disabled when creating an application, please select "WIP".'
          }
        })
      }
      return fieldMetadata[fieldName]['values']
    } else if (subKey && fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName][subKey] && fieldMetadata[fieldName][subKey]['values']) {
      return fieldMetadata[fieldName][subKey]['values']
    } else {
      return []
    }
  }


  const getMultiInputFieldValues = (fieldName) => {
    if (renderJsonEdited && renderJsonEdited[fieldName]) {
      return renderJsonEdited[fieldName]
    } else {
      return []
    }
  }

  const updateValue = (fieldName, value, subKey = null) => {
    if (subKey) {
      if (!renderJsonEdited.hasOwnProperty(fieldName)) {
        renderJsonEdited[fieldName] = {}
      }
      renderJsonEdited[fieldName][subKey] = value
    } else {
      renderJsonEdited[fieldName] = value
    }
    setRenderJsonEdited(JSON.parse(JSON.stringify(renderJsonEdited)))
  }

  const getValue = (fieldName, subKey = null) => {
    if (subKey) {
      if (renderJsonEdited.hasOwnProperty(fieldName)) {
        return renderJsonEdited[fieldName][subKey]
      } else {
        return null
      }
    } else {
      return renderJsonEdited ? renderJsonEdited[fieldName] : null
    }
  }

  const getMultiSelectedOptions = (fieldName) => {
    let arr = renderJsonEdited[fieldName]
    let selectedOptions = []
    if (arr) {
      arr.forEach((item) => {
        selectedOptions.push({ label: item, value: item })
      })
    }
    return selectedOptions
  }

  const cancelEdition = () => {
    setErrorMessage("")
    setIsEditMode(false)
    setRenderJsonEdited(JSON.parse(JSON.stringify(renderJson)))
  }

  const editApplication = () => {
    setIsEditMode(true)
    const renderingJson = JSON.parse(JSON.stringify(renderJson))
    setRenderJsonEdited(renderingJson)



    let requiredFields = []
    
    if (renderingJson[TEMPLATE_APP.STATUS] === 'Active') {
      requiredFields = [TEMPLATE_APP.APP_ID, TEMPLATE_APP.APP_DESCRIPTION, TEMPLATE_APP.APP_NAME, TEMPLATE_APP.STATUS,
        TEMPLATE_APP.ORGANIZATION, TEMPLATE_APP.AUTOMATION_TOOLS, TEMPLATE_APP.PROCESS_OWNER, 
        TEMPLATE_APP.VP, TEMPLATE_APP.GRC_CONTROL_OWNER, TEMPLATE_APP.CADENCE, 
        TEMPLATE_APP.FINANCIAL_RELEVANCE, TEMPLATE_APP.LEDGER_INFO, TEMPLATE_APP.FINANCIAL_YEAR_IMPACT, 
        TEMPLATE_APP.PERMISSION, TEMPLATE_APP.OUTPUT, TEMPLATE_APP.PDD, 
        TEMPLATE_APP.ANNUAL_MER_SAVINGS, TEMPLATE_APP.LAUNCH_MCM, TEMPLATE_APP.LAUNCH_QQ_YY
      ]
    }
    
    setPreviouslyMissingFields(getMissingFields(renderingJson, requiredFields))
    setActiveTabId('details') // Switch to details tab when entering edit mode
  }

  const addApplication = () => {
    setErrorMessage("")
    let requiredFields = [TEMPLATE_APP.APP_DESCRIPTION, TEMPLATE_APP.APP_NAME, TEMPLATE_APP.STATUS]
    
    // Only require additional fields when status is 'Active'
    if (renderJsonEdited[TEMPLATE_APP.STATUS] === 'Active') {
      requiredFields = requiredFields.concat([
        TEMPLATE_APP.ORGANIZATION, TEMPLATE_APP.AUTOMATION_TOOLS, TEMPLATE_APP.PROCESS_OWNER, 
        TEMPLATE_APP.VP, TEMPLATE_APP.GRC_CONTROL_OWNER, TEMPLATE_APP.CADENCE, 
        TEMPLATE_APP.FINANCIAL_RELEVANCE, TEMPLATE_APP.LEDGER_INFO, TEMPLATE_APP.FINANCIAL_YEAR_IMPACT, 
        TEMPLATE_APP.PERMISSION, TEMPLATE_APP.OUTPUT, TEMPLATE_APP.PDD, 
        TEMPLATE_APP.ANNUAL_MER_SAVINGS, TEMPLATE_APP.LAUNCH_MCM
      ])
    }
    
    let missingFields = getMissingFields(renderJsonEdited, requiredFields)
    
    // Check Launch Date when Status is Active
    if (renderJsonEdited[TEMPLATE_APP.STATUS] === 'Active' && (!renderJsonEdited[TEMPLATE_APP.LAUNCH_QQ_YY] || renderJsonEdited[TEMPLATE_APP.LAUNCH_QQ_YY] === '')) {
      missingFields.push(TEMPLATE_APP.LAUNCH_QQ_YY)
    }
    if (missingFields && missingFields?.length > 0) {
      setErrorMessage('missing mandatory fields : ' + missingFields.join(","))
    } else {
      setShowLoadingIcon(true)
      renderJsonEdited[TEMPLATE_APP.LAST_UPDATED_BY] = userId
      renderJsonEdited[TEMPLATE_APP.CREATED_BY] = userId
      renderJsonEdited[TEMPLATE_APP.TEMPLATE_ID] = TEMPLATES.MAPLE
      // setRenderJson(renderJsonEdited)
      if (renderJsonEdited.hasOwnProperty("processes")) {
        delete renderJsonEdited['processes']
      }
      createAuditLog(`APP`, `ADD_REQ#${getCurrentTime()}`, updateComments, JSON.stringify({}), JSON.stringify(renderJsonEdited), "ADD REQ", userId)
      addApp(renderJsonEdited, function onSuccess(response) {
        localStorage.removeItem('appsCache'); // Clean expired cache
        setIsNewApp(false)
        setRenderJson(JSON.parse(JSON.stringify(response.data.addAppV2)))
        setShowLoadingIcon(false)
        history.push("/App/" + response.data.addAppV2.app_id)
        setIsFavorite(false)
        setId(response.data.addAppV2.app_id);
        cancelEdition()
        setQuicksightReports([])
      }, function onFailure(error) {
        setErrorMessage(error?.errors[0]?.message)
        setShowLoadingIcon(false)
      })
    }
  }

  const deleteApplication = () => {
    if (updateComments) {
      setShowLoadingIcon(true)
      setErrorMessage("")
      setModalMessage("")
      setUpdateComments("")
      dismissDeleteDialog()
      getApprovalsForApp(id, async function onSuccess(response) {
        if (response.data.getApprovalForAppV2?.length) {
          //error
          setShowLoadingIcon(false)
          setErrorMessage("")
          setModalMessage(`This app is already scheduled for deletion. Approval id : ${response.data.getApprovalForAppV2[0].approval_id}`)
        } else {
          createAuditLog(`APP#${id}`, `DEL_REQ#${getCurrentTime()}`, updateComments, JSON.stringify({ renderJson }), JSON.stringify({}), "DEL REQ", userId)
          let resp = await startWASApproval(
            {
              userAlias: userId,
              stage: currentStage,
              appId: id,
              appName: renderJson[TEMPLATE_APP.APP_NAME],
              comments: updateComments,
              approveResponseNeeded: 1
            })
          if (resp?.workflowInstanceId) {
            createAuditLog(`APP#${id}`, `DEL_REQ#${resp?.workflowInstanceId}`, updateComments, JSON.stringify({ renderJson }), JSON.stringify({}), "DEL REQ", userId)
            deleteAppWithApproval(id, resp.workflowInstanceId, function onSuccess(response) {
              setShowLoadingIcon(false)
              setModalMessage(`Approval request raised. Your app will be deleted once Approved. Approval ID : ${resp.workflowInstanceId}. Please save this approval ID for future references.`)
              // history.push("/")
            }, function onFailure(error) {
              setShowLoadingIcon(false)
              setModalMessage(`An approval was created for deletion. But the auto app delete trigger creation has failed. Please contact admin/ raise tt with this approval ID in the description : ${resp.workflowInstanceId}`)
            })
          } else {
            setModalMessage("Could not create approval for deletion. Please try again")
          }
        }
      }, function onFailure(response) {
        setShowLoadingIcon(false)
        setErrorMessage("Something went wrong. Cannot fetch existing approvals for the app. Please contact admin/ raise a tt")
      })
    } else {
      setModalError("Please provide comments with the reason for deletion")
    }

  }

  const updateApplication = () => {
    setErrorMessage("")
    let requiredFields = [TEMPLATE_APP.APP_ID, TEMPLATE_APP.APP_DESCRIPTION, TEMPLATE_APP.APP_NAME, TEMPLATE_APP.STATUS]
    
    // Only require additional fields when status is 'Active'
    if (renderJsonEdited[TEMPLATE_APP.STATUS] === 'Active') {
      requiredFields = requiredFields.concat([
        TEMPLATE_APP.ORGANIZATION, TEMPLATE_APP.AUTOMATION_TOOLS, TEMPLATE_APP.PROCESS_OWNER, 
        TEMPLATE_APP.VP, TEMPLATE_APP.GRC_CONTROL_OWNER, TEMPLATE_APP.CADENCE, 
        TEMPLATE_APP.FINANCIAL_RELEVANCE, TEMPLATE_APP.LEDGER_INFO, TEMPLATE_APP.FINANCIAL_YEAR_IMPACT, 
        TEMPLATE_APP.PERMISSION, TEMPLATE_APP.OUTPUT, TEMPLATE_APP.PDD, 
        TEMPLATE_APP.ANNUAL_MER_SAVINGS, TEMPLATE_APP.LAUNCH_MCM
      ])
    }
    
    let missingFields = getMissingFields(renderJsonEdited, requiredFields)
    
    // Check Launch Date when Status is Active
    if (renderJsonEdited[TEMPLATE_APP.STATUS] === 'Active' && (!renderJsonEdited[TEMPLATE_APP.LAUNCH_QQ_YY] || renderJsonEdited[TEMPLATE_APP.LAUNCH_QQ_YY] === '')) {
      missingFields.push(TEMPLATE_APP.LAUNCH_QQ_YY)
    }

    const appCreatedYear = (new Date(renderJsonEdited?.created_time_stamp*1000))?.getFullYear();
    const newMissingFields = missingFields?.filter(field => !previouslyMissingFields.includes(field))
    if (
      missingFields && missingFields?.length > 0
      // if an app is Active and created in 2025 or earlier let it update if it adds new data
      && !(
        renderJsonEdited[TEMPLATE_APP.STATUS] === 'Active' 
        && appCreatedYear && appCreatedYear <= 2025 
        && newMissingFields?.length === 0 
        && previouslyMissingFields?.length > missingFields?.length
      )
    ) {
      setErrorMessage('missing mandatory fields : ' + missingFields.join(","))
    } else {
      setShowLoadingIcon(true)
      renderJsonEdited[TEMPLATE_APP.LAST_UPDATED_BY] = userId
      renderJsonEdited[TEMPLATE_APP.TEMPLATE_ID] = TEMPLATES.MAPLE
      if (renderJsonEdited.hasOwnProperty("processes")) {
        delete renderJsonEdited['processes']
      }
      if (updateComments) {
        createAuditLog(`APP#${id}`, `${getCurrentTime()}`, updateComments, JSON.stringify(renderJson), JSON.stringify(renderJsonEdited), "UPDATE REQ", userId)
        setUpdateComments("")
        updateApp(cleanData(renderJsonEdited), function onSuccess(response) {
          localStorage.removeItem('appsCache'); // Clean expired cache
          setRenderJson(JSON.parse(JSON.stringify(response.data.updateAppV2)))
          setShowLoadingIcon(false)
          cancelEdition()
          if (props?.redirectOnUpdate) {
            history.push(props.redirectOnUpdate)
          } else {
            history.push("/App/" + response.data.updateAppV2.app_id)
          }
          setId(response.data.updateAppV2.app_id);
          setQuicksightReports([])
        }, function onFailure(error) {
          setErrorMessage(error?.errors[0]?.message)
          setShowLoadingIcon(false)
        })
      } else {
        setShowLoadingIcon(false)
        setErrorMessage("Please provide your comments for the update")
      }
    }
  }

  const fetchEmbedView = async () => {
    setQuicksightReports([])
    // setEmbedUrl()
    // setActiveReportTabId()
    let quicksightReports = []
    let outputs = renderJson[TEMPLATE_APP.OUTPUT]?.sort((a, b) => a[TEMPLATE_APP_OUTPUT.LABEL].localeCompare(b[TEMPLATE_APP_OUTPUT.LABEL]))

    if (isEditMode) {
      outputs = renderJsonEdited[TEMPLATE_APP.OUTPUT]?.sort((a, b) => a[TEMPLATE_APP_OUTPUT.LABEL].localeCompare(b[TEMPLATE_APP_OUTPUT.LABEL]))
    }
    // the QS can be any index, find the least
    let tabId = outputs?.length
    for (let i = 0; i < outputs?.length; i++) {
      let output = outputs[i]
      if (output[TEMPLATE_APP_OUTPUT.TYPE].toLowerCase() != 'quicksight dashboard') {
        continue
      }
      if (tabId > i) {
        tabId = i
        setActiveReportTabId(`${i}`)
      }

      quicksightReports.push({
        'id': `${i}`,
        'label': output[TEMPLATE_APP_OUTPUT.LABEL],
        'content':
          <div>
          </div>

      })

    }
    setQuicksightReports(quicksightReports)

  }
  const checkIfFormIsSubmittable = () => {
    let missingFields = getMissingFields(renderJsonEdited,
      [TEMPLATE_APP.APP_ID, TEMPLATE_APP.APP_DESCRIPTION, TEMPLATE_APP.APP_NAME, { mainKey: TEMPLATE_APP.ACCOUNTING_TEAM, subKeys: [TEMPLATE_APP_TEAM.TEAM] },
      { mainKey: TEMPLATE_APP.OUTPUT, subKeys: [TEMPLATE_APP_OUTPUT.TYPE] }])
    setEnableEditAction(missingFields?.length <= 0)
  }
  const getDate = (value) => {
    var d = new Date(parseFloat(value) * 1000)
    return d.toLocaleString()
  }
  const dismissDeleteDialog = () => {
    setDeleteAppName('')
    setDeleteConfirmationModal(false)
  }
  const postProcessTeamEmails = (value) => {
    return value.replaceAll("@amazon.com", "")
  }

  const shouldShowMandatory = () => {
    // Show mandatory indicators only when status is 'Active'
    return getValue(TEMPLATE_APP.STATUS) === 'Active'
  }

  const lastUpdatedContent = (<>
    {getValue(TEMPLATE_APP.LAST_UPDATED_TIME_STAMP) ? <>

      <span className="last_updated"> Last updated : <span className="bold">{getDate(getValue(TEMPLATE_APP.LAST_UPDATED_TIME_STAMP))}</span></span>
      {getValue(TEMPLATE_APP.LAST_UPDATED_BY) ? <span className="last_updated"> by  <span className="bold">{getValue(TEMPLATE_APP.LAST_UPDATED_BY)}</span></span> : ''}
    </> : ''}
  </>)

  const accountingValidation = (elements) => {
    let emptyTeam = true
    elements.forEach((element) => {
      if (!element.team) {
        emptyTeam = false
      }
    })
    return emptyTeam
  }

  const uploadAnnotationAppendInput = async () => {
    const file = annotationInputFile[0]
    setAnnotationUploadLoader("Loading..")
    const data = await file.arrayBuffer();
    let text = new TextDecoder().decode(data);
    let result = d3.csvParse(text)
    result = result.map(item => ({
      ...item,
      isNew: true
    }));
    setAnnotationError(null)
    setDsInfo(dsInfo.concat(result))
    setUndoEditCount(undoEditCount + 1)
    setShowAnnotationImportAppendModal(false)
    resetAnnotationModalView()

  }
  const uploadAnnotationInput = async () => {
    configureGenericS3()
    const file = annotationInputFile[0]
    let level = annotationLevel
    let prefix = annotationPrefix
    setAnnotationUploadLoader("Uploading..")
    let putResp = await Storage.vault.put(annotationFileName, file, {
      level: level,
      customPrefix: { public: prefix },
      acl: 'bucket-owner-full-control'
    })
    setShowAnnotationImportModal(false)
    resetAnnotationModalView()
    getAnnotationInput()
  }

  const resetGridView = () => {
    if (gridRef.current) {
      const gridApi = gridRef.current.api;
      const columnApi = gridRef.current.columnApi;

      // Clear Filters
      gridApi?.setFilterModel(null);

      // Clear Sorting
      columnApi?.applyColumnState({
        defaultState: { sort: null },
      });

      // Reset Columns
      columnApi?.resetColumnState();

      // Reset Pinned Columns
      columnApi?.setPivotMode(false);

      // // Resize to fit
      // gridApi?.sizeColumnsToFit();

      // Redraw the grid
      gridApi?.redrawRows();
    }
  };

  const validateAnnotationInput = async () => {
    try {
      const data = await annotationInputFile[0].arrayBuffer();
      const workbook = XLSX.read(data)
      const worksheet = workbook.Sheets[workbook.SheetNames[0]]
      var readOptions = { type: 'binary', raw: false, defval: null, cellNF: false, cellDates: true, cellText: false }
      const headerInfo = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "", raw: false, cellDates: true })
      const colNames = headerInfo[0]
      setAnnotationColumns(colNames)
    } catch (e) {
      setAnnotationColumns([])
    }
  }

  const getAnnotationInput = async (isSave = false) => {
    setAnnotationLoader('Loading..')
    setAnnotationError(null)
    setDsInfo(null)
    setColumnsList(null)
    setSelectedRowIndex(null)
    setUndoEditCount(0)
    setMultiSelectedRow([])
    setAggregationValues(null)
    if (!isSave) {
      resetGridView()
    }
    configureGenericS3()
    let level = annotationLevel
    let prefix = annotationPrefix
    let fileURL = await Storage.get(annotationFileName, { level: level, customPrefix: { public: prefix }, expires: 60 });
    let csvdata = await d3.csv(fileURL).then((result) => {
      setDsInfo(result);
      if (result?.columns) {
        const definitions = []
        for (let i = 0; i < result?.columns?.length; i++) {
          let colName = result?.columns[i]
          let def = {
            field: colName, headerName: colName, resizable: true, sortable: true, enableRowGroup: true, editable: false, cellSelection: 'enabled',
            filterParams: {
              closeOnApply: false,
              buttons: ['apply', 'clear'],
              defaultOption: 'contains'
            },
            cellClass: (params) => {
              return [
                params?.data?.isEdited?.hasOwnProperty(colName) ? 'edited-cell' : '',
                (currencyColumns.includes(colName.toLowerCase()) || editableColumns.includes(colName.toLowerCase())) ? 'editable-cell' : '',
              ].filter(Boolean);  // removes empty strings
            }
          }
          if (i == 0) {
            def['checkboxSelection'] = true
            def['headerCheckboxSelection'] = true
          }
          if (unEditableColumns.includes(colName)) {
            def['editable'] = false
          }
          if (editableColumns.includes(colName)) {
            def['editable'] = true
          }
          if (colName == 'Period - Quarter') {
            def['cellEditor'] = 'agSelectCellEditor'
            def['cellEditorParams'] = {
              values: ["Q1", "Q2", "Q3", "Q4"],
            }
          }
          if (currencyColumns.includes(colName.toLowerCase())) {
            def['valueFormatter'] = currencyFormatter
            def['valueGetter'] = (params) => { return Number(params.data?.[colName]) }
            def['valueParser'] = (params) => {
              // Ensure values are numbers
              return Number(params.newValue);
            }
            def['cellDataType'] = CellDataType.NUMBER
            def['aggFunc'] = 'sum'
            def['editable'] = true
          }
          // if(pivotColumns.includes(colName)){
          //   def['pivot'] = true
          // }

          definitions.push(def)
        }
        setColumnsList(definitions)
      }
      setAnnotationLoader(null)
      setAnnotationError(null)
    }).catch((response) => {
      setAnnotationLoader(null)
      setAnnotationError('Loading failed')
    });
  }


  const resetAnnotationModalView = () => {
    setModalMessage("")
    setAnnotationUploadLoader(null)
    setAnnotationInputFile([])
    setAnnotationColumns([])
    setAnnotationLoader(null)
    setAnnotationError(null)
  }

  // Function to check TANC association status for a process
  const checkTANCAssociationStatus = async (processId, associationType = 'FRISCO') => {
    const cacheKey = `${processId}_${associationType}`;
    
    // Check if we already have the status cached
    if (tancStatusCache[cacheKey] !== undefined) {
      return tancStatusCache[cacheKey];
    }

    try {
      const response = await new Promise((resolve, reject) => {
        tancAssociationStatus(processId, associationType, resolve, reject);
      });
      
      const status = response?.data?.tancAssociationStatus?.status || false;
      
      // Cache the result
      setTancStatusCache(prev => ({
        ...prev,
        [cacheKey]: status
      }));
      
      return status;
    } catch (error) {
      return false;
    }
  };

  // Enhanced process click handler with TANC status checking
  const handleProcessClick = async (process, actionType = 'upload') => {
    try {
      // Check TANC association status before proceeding
      const hasTANCAssociation = await checkTANCAssociationStatus(process.process_id, 'FRISCO');
      
      // Proceed with the original click logic
      const baseUrl = `/App/${id}/process/${process.process_id}/${actionType}`;
      setSelectedProcessUrl(baseUrl);
      
      // Create sidebar content - always include basic tabs
      let sidebarContent = [
        { label: 'History', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/history`); setActiveProcessTab('history'); } },
        { label: 'Settings', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}`); setActiveProcessTab('settings'); } },
        { label: 'Audit logs', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/FriscoProcessAuditLogs`); setActiveProcessTab('audit_logs'); } }
      ];
      
      // Add Upload tab for all processes
      sidebarContent.unshift(
        { label: 'Upload', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/upload`); setActiveProcessTab('upload'); } }
      );
      
      // Add Edit in UI tab ONLY if TANC association status is true
      if (hasTANCAssociation) {
        sidebarContent.splice(1, 0, 
          { label: 'Edit in UI', action: () => { setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/upload?mode=inline_edit`); setActiveProcessTab('inline_edit'); } }
        );
      }
      
      setSelectedSidebarContent(sidebarContent);
      setSelectedSidebarItemId(process.process_id);
      searchParams.delete('processId')
      searchParams.append('processId', process.process_id)
      history.replace({
      ...history.location.search,
      search: `${searchParams.toString()}`,
    })
      setActiveProcessTab(actionType);
      
      // Cache the tabs configuration for this process
      setFriscoProcessTabs(prev => ({
        ...prev,
        [process.process_id]: {
          hasTANCAssociation,
          tabs: hasTANCAssociation ? [
            { label: "Upload", id: "upload" },
            { label: "Edit in UI", id: "inline_edit" },
            { label: "History", id: "history" },
            { label: "Settings", id: "settings" },
            { label: "Audit logs", id: "audit_logs" }
          ] : [
            { label: "Upload", id: "upload" },
            { label: "History", id: "history" },
            { label: "Settings", id: "settings" },
            { label: "Audit logs", id: "audit_logs" }
          ]
        }
      }));
      
    } catch (error) {
      // Fallback to original behavior if TANC check fails
      setSelectedProcessUrl(`/App/${id}/process/${process.process_id}/${actionType}`);
      setSelectedSidebarItemId(process.process_id);
      searchParams.delete('processId')
      searchParams.append('processId', process.process_id)
      history.replace({
      ...history.location.search,
      search: `${searchParams.toString()}`,
    })
      setActiveProcessTab(actionType);
    }
  };

  // Function to get Frisco tabs for a process (with TANC check)
  const getFriscoTabsForProcess = async (processId) => {
    // Check if we already have cached tabs for this process
    if (friscoProcessTabs[processId]) {
      return friscoProcessTabs[processId];
    }

    // Check TANC association status
    const hasTANCAssociation = await checkTANCAssociationStatus(processId, 'FRISCO');
    
    const tabsConfig = {
      hasTANCAssociation,
      tabs: hasTANCAssociation ? [
        { label: "Upload", id: "upload" },
        { label: "Edit in UI", id: "inline_edit" },
        { label: "History", id: "history" },
        { label: "Settings", id: "settings" },
        { label: "Audit logs", id: "audit_logs" }
      ] : [
        { label: "Upload", id: "upload" },
        { label: "History", id: "history" },
        { label: "Settings", id: "settings" },
        { label: "Audit logs", id: "audit_logs" }
      ]
    };

    // Cache the result
    setFriscoProcessTabs(prev => ({
      ...prev,
      [processId]: tabsConfig
    }));

    return tabsConfig;
  };

  // Load action tabs configuration from most recent admin preference (global)
  const loadActionTabsConfiguration = () => {
    if (!id || isNewApp) return;
    
    setIsLoadingActionTabs(true);
    
    configurePlusAppsync().then(() => {
      listPreference(
        id,  // Use appId as association_id
        'APP',  // Use APP as association_id_type
        'TAB_CONFIGURATION',
        function onSuccess(response) {
          const preferences = response?.data?.listPreference?.items || [];
          
          const validPreferences = preferences.filter(pref => {
            if (pref.information) {
              const information = typeof pref.information === 'string'
                ? JSON.parse(pref.information)
                : pref.information;
              return information && information.tabConfiguration;
            }
            return false;
          });

          // Use the first preference (backend always updates the first record)
          if (validPreferences.length > 0) {
            const firstPreference = validPreferences[0];

            const information = typeof firstPreference.information === 'string'
              ? JSON.parse(firstPreference.information)
              : firstPreference.information;

            if (information && information.tabConfiguration) {
              // Merge admin configuration with default configuration
              const adminConfig = information.tabConfiguration;
              const mergedConfig = mergeTabConfigurations(adminConfig, DEFAULT_ACTION_TABS_CONFIG);

              setActionTabsConfiguration(mergedConfig);
              setIsLoadingActionTabs(false);
              return;
            }
          }
          
          // Fallback to default configuration if no valid preferences found
          setActionTabsConfiguration(DEFAULT_ACTION_TABS_CONFIG);
          setIsLoadingActionTabs(false);
        },
        function onFailure(error) {
          console.error('Error loading preferences:', error);
          setActionTabsConfiguration(DEFAULT_ACTION_TABS_CONFIG);
          setIsLoadingActionTabs(false);
        }
      );
    }).catch((error) => {
      console.error('Error configuring AppSync:', error);
      setActionTabsConfiguration(DEFAULT_ACTION_TABS_CONFIG);
      setIsLoadingActionTabs(false);
    });
  };

  // Helper function to merge user configuration with default configuration
  // Ensures new tabs from defaults are automatically added to user's config
  const mergeTabConfigurations = (userConfig, defaultConfig) => {
    try {
      const userActionTabs = Array.isArray(userConfig?.actionTabs) ? userConfig.actionTabs : [];
      const userCustomActionTabs = Array.isArray(userConfig?.customActionTabs) ? userConfig.customActionTabs : [];
      const defaultActionTabs = Array.isArray(defaultConfig?.actionTabs) ? defaultConfig.actionTabs : [];
      
      // Create a map of existing tab IDs from user's configuration
      const existingTabIds = new Set([
        ...userActionTabs.map(tab => tab.id),
        ...userCustomActionTabs.map(tab => tab.id)
      ]);
      
      // Find tabs from default config that are missing in user's config
      const missingTabs = defaultActionTabs.filter(defaultTab => !existingTabIds.has(defaultTab.id));
      
      // If there are missing tabs, add them to user's action tabs
      if (missingTabs.length > 0) {
        // Find the highest order value in user's existing tabs
        const maxOrder = Math.max(
          ...userActionTabs.map(tab => tab.order || 0),
          ...userCustomActionTabs.map(tab => tab.order || 0),
          0
        );
        
        // Add missing tabs with incremented order values
        const newTabs = missingTabs.map((tab, index) => ({
          ...tab,
          order: maxOrder + index + 1
        }));
        
        return {
          actionTabs: [...userActionTabs, ...newTabs],
          customActionTabs: userCustomActionTabs
        };
      }
      
      // No missing tabs, return user's config as-is
      return userConfig;
    } catch (error) {
      console.error('Error merging tab configurations:', error);
      // On error, return default config as fallback
      return defaultConfig;
    }
  };

  // Default action tabs configuration
  const DEFAULT_ACTION_TABS_CONFIG = {
    actionTabs: DEFAULT_TABS.map(tab => ({ ...tab })),
    customActionTabs: []
  };

  const getDynamicActionTabs = () => {
    const configToUse = actionTabsConfiguration || DEFAULT_ACTION_TABS_CONFIG;

    try {
      const actionTabs = Array.isArray(configToUse?.actionTabs) ? configToUse.actionTabs : [];
      const customActionTabs = Array.isArray(configToUse?.customActionTabs) ? configToUse.customActionTabs : [];

      const allTabs = [
        ...actionTabs,
        ...customActionTabs
      ];

      return allTabs
        .filter(tab => tab && tab.visible)
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map((tab, index) => ({
          label: tab.label || `Tab ${index + 1}`,
          id: tab.id || `tab_${index}`,
          content: <div></div> 
        }));
    } catch (error) {
      return [];
    }
  };

  const handleAddNewClick = () => {
    setShowAddProcessModal(true);
  };

  const handleAddProcessModalDismiss = () => {
    setShowAddProcessModal(false);
    setSelectedProcessType(null);
  };

  const handleProcessTypeSelection = () => {
    if (!selectedProcessType) return;
    
    setShowAddProcessModal(false);
    if (selectedProcessType === 'frisco') {
      history.push(`/App/${id}/process`);
    } else if (selectedProcessType === 'logico') {
      history.push(`/App/${id}/LogicoProcess`);
    } else if (selectedProcessType === 'flexico') {
      history.push(`/App/${id}/flexico`);
    }
    
    setSelectedProcessType(null);
  };

  // Handler for process selection from sidebar
  const handleProcessSelect = async (processType, processId, defaultTab) => {
    if (processType === 'flexico') {
      // Set all state in one batch to prevent multiple renders
      setSelectedSidebarItemId(processId);
      setActiveProcessTab('execute');
      setSelectedProcessUrl(`/App/${id}/flexico/${processId}/upload`);
      
      // Update URL
      searchParams.delete('processId');
      searchParams.append('processId', processId);
      searchParams.delete('processPage');
      searchParams.append('processPage', 'execute');
      history.replace({
        ...history.location.search,
        search: `${searchParams.toString()}`,
      });
      
      // Set sidebar content for Flexico - actions will only be called by user tab clicks
      const flexicoTabs = [
        { label: 'Execute', action: () => { 
          setSelectedProcessUrl(`/App/${id}/flexico/${processId}/upload`); 
          setActiveProcessTab('execute'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'execute'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'History', action: () => { 
          setSelectedProcessUrl(`/App/${id}/flexico/${processId}/history`); 
          setActiveProcessTab('history'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'history'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'Settings', action: () => { 
          setSelectedProcessUrl(`/App/${id}/flexico/${processId}`); 
          setActiveProcessTab('settings'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'settings'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'Audit logs', action: () => { 
          setSelectedProcessUrl(`/App/${id}/flexico/${processId}/FlexicoProcessAuditLogs`); 
          setActiveProcessTab('audit_logs'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'audit_logs'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } }
      ];
      setSelectedSidebarContent(flexicoTabs);
    } else if (processType === 'logico') {
      // Set all state in one batch to prevent multiple renders
      setSelectedSidebarItemId(processId);
      setActiveProcessTab('upload');
      setSelectedProcessUrl(`/App/${id}/LogicoProcess/${processId}/upload`);
      
      // Update URL
      searchParams.delete('processId');
      searchParams.append('processId', processId);
      searchParams.delete('processPage');
      searchParams.append('processPage', 'upload');
      history.replace({
        ...history.location.search,
        search: `${searchParams.toString()}`,
      });
      
      // Set sidebar content for Logico - actions will only be called by user tab clicks
      const logicoTabs = [
        { label: 'Upload', action: () => { 
          setSelectedProcessUrl(`/App/${id}/LogicoProcess/${processId}/upload`); 
          setActiveProcessTab('upload'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'upload'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'History', action: () => { 
          setSelectedProcessUrl(`/App/${id}/LogicoProcess/${processId}/history`); 
          setActiveProcessTab('history'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'history'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'Settings', action: () => { 
          setSelectedProcessUrl(`/App/${id}/LogicoProcess/${processId}`); 
          setActiveProcessTab('settings'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'settings'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'Audit logs', action: () => { 
          setSelectedProcessUrl(`/App/${id}/LogicoProcess/${processId}/LogicoProcessAuditLogs`); 
          setActiveProcessTab('audit_logs'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'audit_logs'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } }
      ];
      setSelectedSidebarContent(logicoTabs);
    } else if (processType === 'frisco') {
      // Set initial state
      setSelectedSidebarItemId(processId);
      setActiveProcessTab('upload');
      setSelectedProcessUrl(`/App/${id}/process/${processId}/upload`);
      
      // Update URL
      searchParams.delete('processId');
      searchParams.append('processId', processId);
      searchParams.delete('processPage');
      searchParams.append('processPage', 'upload');
      history.replace({
        ...history.location.search,
        search: `${searchParams.toString()}`,
      });
      
      // Pre-load the tabs configuration for this process
      const tabsConfig = await getFriscoTabsForProcess(processId);
      
      // Set sidebar content for Frisco based on TANC association - actions will only be called by user tab clicks
      let friscoTabs = [
        { label: 'Upload', action: () => { 
          setSelectedProcessUrl(`/App/${id}/process/${processId}/upload`); 
          setActiveProcessTab('upload'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'upload'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } }
      ];
      
      // Add Edit in UI tab if TANC association exists
      if (tabsConfig?.hasTANCAssociation) {
        friscoTabs.push(
          { label: 'Edit in UI', action: () => { 
            setSelectedProcessUrl(`/App/${id}/process/${processId}/upload?mode=inline_edit`); 
            setActiveProcessTab('inline_edit'); 
            const params = new URLSearchParams(location.search);
            params.set('processId', processId);
            params.set('processPage', 'inline_edit'); 
            history.replace({ ...history.location, search: params.toString() }); 
          } }
        );
      }
      
      // Add remaining tabs
      friscoTabs.push(
        { label: 'History', action: () => { 
          setSelectedProcessUrl(`/App/${id}/process/${processId}/history`); 
          setActiveProcessTab('history'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'history'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'Settings', action: () => { 
          setSelectedProcessUrl(`/App/${id}/process/${processId}`); 
          setActiveProcessTab('settings'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'settings'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } },
        { label: 'Audit logs', action: () => { 
          setSelectedProcessUrl(`/App/${id}/process/${processId}/FriscoProcessAuditLogs`); 
          setActiveProcessTab('audit_logs'); 
          const params = new URLSearchParams(location.search);
          params.set('processId', processId);
          params.set('processPage', 'audit_logs'); 
          history.replace({ ...history.location, search: params.toString() }); 
        } }
      );
      
      setSelectedSidebarContent(friscoTabs);
    }
  };

  // Handler for adding new process from sidebar
  const handleAddNewProcess = () => {
    // Set special 'new' ID to trigger add mode in inline view
    setSelectedSidebarItemId('new');
    setSelectedSidebarContent(null);
    setActiveProcessTab('settings');
    
    // Update URL parameters
    searchParams.delete('processId');
    searchParams.delete('processPage');
    searchParams.append('processId', 'new');
    searchParams.append('processPage', 'settings');
    history.replace({
      ...history.location.search,
      search: `${searchParams.toString()}`,
    });
    
    // Set the appropriate process URL based on active tab
    if (activeSubTabId === 'run') {
      setSelectedProcessUrl(`/App/${id}/flexico/new`);
    } else if (activeSubTabId === 'upload') {
      setSelectedProcessUrl(`/App/${id}/process/new`);
    } else if (activeSubTabId === 'categorize') {
      setSelectedProcessUrl(`/App/${id}/LogicoProcess/new`);
    }
  };

  const saveAnnotated = () => {
    setAnnotationLoader("Saving the data..")
    let data = gridRef.current?.api.getDataAsCsv({
      'exportedRows': 'all', processCellCallback: (params) => {
        // Access raw data directly from node.data
        const rawValue = params.node.data[params.column.colDef.field];
        return rawValue;
      },
    })
    Storage.put(annotationFileName, data, {
      level: annotationLevel,
      customPrefix: { public: annotationPrefix }
    })
      .then((result) => {
        setAnnotationSaveSuccessMessage("Data saved successfully")
        setTimeout(() => {
          setAnnotationSaveSuccessMessage(null)
        }, 1000);
        getAnnotationInput(true)
      })
      .catch(err => setAnnotationError("Saving failed"));
  }

  const addRowToAnnotation = (data = {}) => {
    let copy = Object.assign({}, data)
    copy['isNew'] = true
    dsInfo.splice(0, 0, copy);
    setDsInfo([...dsInfo])
    setUndoEditCount(undoEditCount + 1)
  }
  const delRowToAnnotation = () => {
    // sort descending to you can remove from greatest index to smallest

    for (let i = 0; i < multiSelectedRow?.length; i++) {
      dsInfo.splice(multiSelectedRow[i].rowIndex, 1);
    }
    setDsInfo([...dsInfo])
    setUndoEditCount(undoEditCount + 1)
    // dsInfo.splice(selectedRowIndex, 1);
    // setDsInfo([...dsInfo])
    // setUndoEditCount(undoEditCount+1)
  }

  const exportAnnotated = (args = {}) => {
    let csv = gridRef.current?.api.exportDataAsCsv({
      'fileName': annotationFileName,
      'exportedRows': args.filtered ? 'filteredAndSorted' : 'all',
      'onlySelected': args.selectedOnly,
      processCellCallback: (params) => {
        // Access raw data directly from node.data
        if (params.node.group) {
          // Access grouped value
          return params.value;
        } else {
          const rawValue = params.node.data[params.column.colDef.field];
          return rawValue;
        }

      }
    });
    // gridRef.current?.api.exportDataAsExcel()
  }

  function currencyFormatter(params) {
    if (isNumberAfterParsed(params.value)) {
      return "$" + formatNumber(params.value);
    } else {
      return '-'
    }

  }

  function formatNumber(number) {
    return Math.floor(number).toLocaleString();
  }

  function formatFloatNumber(number) {
    return number.toLocaleString();
  }

  const onCellValueChanged = useCallback((params) => {
    const undoSize = params.api.getCurrentUndoSize();
    setUndoEditCount(undoSize)

    if (params.oldValue !== params.newValue) {
      let editedCols = params.data.isEdited || {}
      if (editedCols.hasOwnProperty(params.column.colId)) {
        // store original old value
        editedCols[params.column.colId] = { oldValue: editedCols[params.column.colId]?.oldValue, newValue: params.newValue }
      } else {
        // new entry
        editedCols[params.column.colId] = { oldValue: params.oldValue, newValue: params.newValue }
      }
      params.data.isEdited = editedCols;
    }
    params.api.refreshCells();
  }, []);

  const onCellFocused = useCallback((params) => {
    setSelectedRowIndex(params.rowIndex)
  }, []);

  const onSelectionChanged = (param) => {
    const selectedNodes = gridRef.current.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => ({
      rowIndex: node.rowIndex,
      data: node.data
    }));
    setMultiSelectedRow(selectedData.sort((a, b) => b.rowIndex - a.rowIndex))
  };

  const undo = useCallback(() => {
    gridRef.current.api.undoCellEditing();
  }, []);

  const redo = useCallback(() => {
    gridRef.current.api.redoCellEditing();
  }, []);

  const onGridReady = useCallback((params) => {
    // gridRef?.current?.api.sizeColumnsToFit();
    const allColumnIds = [];
    gridRef?.current?.api?.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridRef?.current?.api?.autoSizeColumns(allColumnIds);
    updateGridInfo()
  }, []);

  const isNumber = (value) => {
    try {
      if (typeof value === 'number' && !isNaN(value)) {
        return true;
      }
      // if (typeof value === 'string' && !isNaN(Number(value))) {
      //   return true;
      // }
      return false;
    } catch (e) {
      return false
    }
  };

  const isNumberAfterParsed = (value) => {
    try {
      if (typeof value === 'number' && !isNaN(value)) {
        return true;
      }
      if (typeof value === 'string' && !isNaN(Number(value))) {
        return true;
      }
      return false;
    } catch (e) {
      return false
    }
  };

  const getContextMenuItems = (params) => {
    return [
      'copy',
      'copyWithHeaders',
      // 'paste',
      'separator',
      'export',
      'separator',
      {
        name: 'Clone',
        action: () => {
          addRowToAnnotation(params.node.data)
        }
      }
    ];
  }

  const onFilterChanged = () => {
    updateGridInfo();
  };

  const onViewportChanged = () => {
    updateGridInfo();
  };

  const updateGridInfo = () => {
    if (gridRef?.current?.api) {
      const api = gridRef.current.api;
      setGridInfo({
        rowCount: api?.getDisplayedRowCount(),
        totalRows: dsInfo?.length,
      });
    }
  };

  const onRangeSelectionChanged = useCallback((event) => {
    setAggregationValues(null)
    const gridApi = event.api;
    const cellRanges = gridRef?.current?.api?.getCellRanges();
    let count = 0
    let min = null
    let max = null
    let sum = 0

    if (cellRanges) {
      cellRanges.forEach(range => {
        range.columns.forEach(column => {
          const colId = column?.getColId();
          const valueGetter = column?.getColDef()?.valueGetter;

          for (let rowIndex = range?.startRow?.rowIndex; rowIndex <= range?.endRow?.rowIndex; rowIndex++) {
            const node = gridApi?.getDisplayedRowAtIndex(rowIndex);
            if (!node) continue;

            let value;
            if (valueGetter) {
              value = valueGetter({
                data: node?.data,
                node: node,
                column: column,
                api: gridApi
              });
            } else {
              value = node?.data[colId];
            }

            if (!isNumber(value)) {
              continue
            }
            count = count + 1
            sum = sum + value
            if (min == null || value < min) {
              min = value
            }
            if (max == null || value > max) {
              max = value
            }
          }
        });
      });
    }
    if (count > 0) {
      setAggregationValues({
        'average': formatFloatNumber(sum / count),
        'count': count,
        'sum': formatFloatNumber(sum),
        'min': formatFloatNumber(min),
        'max': formatFloatNumber(max)
      })
    }

  }, [])

  const onColumnRowGroupChanged = useCallback(() => {
    setRowGroupColumns(gridRef?.current?.api?.getRowGroupColumns())
    updateGridInfo()
  }, [])
  const handleViewChanges = () => {
    setShowOldValues(!showOldValues)
  }

  const appDetails = (
    <>
      <SpaceBetween size="l">
        <TilesContainer
          renderJsonEdited={renderJsonEdited}
          isEditable={isEditable}
          getValue={getValue}
          updateValue={updateValue}
          getSelectFieldValues={getSelectFieldValues}
          getMultiInputFieldValues={getMultiInputFieldValues}
          getMultiSelectedOptions={getMultiSelectedOptions}
          shouldShowMandatory={shouldShowMandatory}
          mandatoryFieldListener={mandatoryFieldListener}
          postProcessTeamEmails={postProcessTeamEmails}
          accountingValidation={accountingValidation}
          suggestedLogins={suggestedLogins}
          getSuggestedLoginsCaller={getSuggestedLoginsCaller}
          aliasesLoading={aliasesLoading}
          directReports={directReports}
          getDirectReportsCaller={getDirectReportsCaller}
          directReportsLoading={directReportsLoading}
          canEdit={canEdit}
          featuredPressed={featuredPressed}
          setFeaturedPressed={setFeaturedPressed}
          markFeatured={markFeatured}
          id={id}
          isNewApp={isNewApp}
          isEditMode={isEditMode}
          dataFromMeta={dataFromMeta}
          userId={userId}
          isSupportAdmin={isSupportAdmin}
          accountingOrg={accountingOrg}
          usecaseRunFrequency={usecaseRunFrequency}
          usecaseType={usecaseType}
          financialRelevance={financialRelevance}
          usecaseInputSourceTypes={usecaseInputSourceTypes}
          usecaseAutomationTools={usecaseAutomationTools}
          usecaseLedgerImpact={usecaseLedgerImpact}
          usecaseRegions={usecaseRegions}
        />

        <Box>
          {errorMessage && (
            <Box variant="p" color="text-status-error">
              {errorMessage}
            </Box>
          )}
        </Box>
        {
          (isNewApp && canAdd) ?
            <Box className="buttons">
              <SpaceBetween direction="horizontal" size="l">
                {enableEditAction ? <Button variant="primary" onClick={addApplication} >Save</Button> :
                  <Button variant="primary" onClick={addApplication} >Save</Button>}

              </SpaceBetween>
            </Box>
            :
            ''
        }
        {
          !isNewApp && isEditMode ?
            <SpaceBetween direction="vertical" size="l">
              <Textarea
                class="description"
                onChange={({ detail }) => setUpdateComments(detail.value)}
                value={updateComments}
                placeholder="Comments"
              ></Textarea>
              <Box className="buttons">
                <SpaceBetween direction="horizontal" size="l">
                  {enableEditAction ? <Button variant="primary" onClick={updateApplication}  >Update</Button> :
                    <Button variant="primary" onClick={updateApplication} disabled={enableEditAction} >Update</Button>}

                  <Button onClick={cancelEdition}>Cancel</Button>
                </SpaceBetween>
              </Box>
            </SpaceBetween>
            :
            ''
        }
      </SpaceBetween>

      {modalMessage ?
        <Modal
          onDismiss={() => { resetAnnotationModalView() }}
          visible={modalMessage}
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="primary" onClick={() => { setModalMessage("") }}>Ok</Button>
              </SpaceBetween>
            </Box>
          }
        >
          <Box>{modalMessage}</Box>
        </Modal> : ''}
    </>
  );

  const appHeader = (
    <SpaceBetween size="l">
      {
        alertErrorMessage ? <Alert
          statusIconAriaLabel="Error"
          type="error"
          header={alertErrorMessage?.header}
        >
          {alertErrorMessage?.message}
        </Alert> : ''
      }
        {/* Back Button */}
        {!isNewApp && !isInIframe && (
          <div style={{ paddingLeft: !appNavOpen ? '48px' : '0' }}>
              <Button 
              className="back-button"
                variant="inline-link"
                iconName="angle-left"
                onClick={() => history.push('/AppsLibrary')}
              >
                Back to Application Repository
              </Button>
          </div>
        )}
      {
        isEditable(TEMPLATE_APP.APP_NAME) ?
          <Box> <CustomInput field={TEMPLATE_APP.APP_NAME} placeholder="App name" updateValue={updateValue} getValue={getValue} required={true} mandatoryFieldListener={mandatoryFieldListener}></CustomInput> </Box> :
          <Grid
              gridDefinition={[{ colspan: 10 }, { colspan: 2}]}
          > 
          <Box variant="h1">
            
            
            <span className="custom-home__header-title">{usecaseName}</span>
                        
            
            <span></span>
            <img className="favorite_icon" src={isFavorite ? favLogoSolid : favLogo} onClick={() => markFavorite(id)} ></img>
            {!isEditable(TEMPLATE_APP.STATUS) && usecaseStatus && (
              <Badge
                color={
                  usecaseStatus === "Active" ? "green" :
                  usecaseStatus === "Deprecated" ? "red" :
                  "blue"
                }
              >
                {usecaseStatus}
              </Badge>
            )}
            {
              isNewApp ?
                '' :
                canEdit ?
                  (isEditMode) ?
                    '' :
                    <span>
                      <Button iconName="edit" variant="icon" onClick={editApplication} />
                      {canDelete ? <Button iconName="remove" variant="icon" onClick={() => { setDeleteConfirmationModal(true) }} /> : ''}
                      { (canDownload && usecaseStatus === 'Active') && <Button iconName="download" variant="icon" onClick={() => setShowDownloadModal(true)} /> }
                      { showDownloadModal && <DownloadAppModal appId={props.id} appData={renderJson} processes={{ flexico: flexicoTemplates, frisco: subProcesses, logico: logicoProcesses}} hideModal={() => setShowDownloadModal(false)} />}
                      <Modal
                        onDismiss={dismissDeleteDialog}
                        visible={deleteConfirmationModal}
                        footer={
                          <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                              <Button variant="link" onClick={dismissDeleteDialog} >Cancel</Button>
                              <Button disabled={deleteAppName !== renderJson[TEMPLATE_APP.APP_NAME]} variant="primary" onClick={deleteApplication}  >Confirm</Button>
                            </SpaceBetween>
                          </Box>
                        }
                        header={
                          <React.Fragment>
                            <Box variant="h2">
                              Delete confirmation for '{renderJson[TEMPLATE_APP.APP_NAME]}'
                            </Box>
                          </React.Fragment>
                        }
                      >
                        <SpaceBetween direction="vertical" size="m">
                          <Box>To confirm deletion, enter the name of the app in the text input field below</Box>
                          <Box>
                            <Input placeholder={renderJson[TEMPLATE_APP.APP_NAME]} onChange={({ detail }) => setDeleteAppName(detail.value)} value={deleteAppName} />
                          </Box>
                          <Box>
                            <Textarea
                              class="description"
                              onChange={({ detail }) => setUpdateComments(detail.value)}
                              value={updateComments}
                              placeholder="Comments"
                            ></Textarea>
                          </Box>
                          <Box>
                            {modalError && (
                              <Box variant="p" color="text-status-error">
                                {modalError}
                              </Box>
                            )}
                          </Box>
                        </SpaceBetween>



                      </Modal>
                      <>{lastUpdatedContent}</>
                     
                    </span>
                  :
                  <>{lastUpdatedContent}</>
            }
          </Box>
          <Box>
            {!isInIframe && (
              <Button 
                  variant="primary"
                  // iconName="angle-left"
                  onClick={() =>{setAddToCPModalVisible(true)}}
                >
                  Add to Workspace
            </Button>
            )}
            
              {addToCPModalVisible && (<AddToCPModal visible={addToCPModalVisible} onDismiss={()=>{setAddToCPModalVisible(false)}}
                resourceURL={`${ln.pathname}${location.search}`}/>)}
            </Box>        
          </Grid>
      }
      {isEditable(TEMPLATE_APP.APP_DESCRIPTION) && (
        <Grid
          gridDefinition={[{ colspan: 10 }, { colspan: 2 }]}
        >
          <div> <Textarea
            class="description"
            onChange={({ detail }) => updateValue(TEMPLATE_APP.APP_DESCRIPTION, detail.value)}
            value={getValue(TEMPLATE_APP.APP_DESCRIPTION)}
            placeholder="Description"
          /> </div>
          <div> <span className="mandatory" style={{ visibility: shouldShowMandatory() ? 'visible' : 'hidden' }}>*</span> </div>
        </Grid>
      )}

      {
              isEditable(TEMPLATE_APP.STATUS)
                ?
                <Grid
                gridDefinition={[{ colspan: 10 }, { colspan: 2 }]}>
                <CustomSelect field={TEMPLATE_APP.STATUS} getValue={getValue} updateValue={updateValue} getOptions={getSelectFieldValues} />
                <span className="mandatory" style={{ visibility: shouldShowMandatory() ? 'visible' : 'hidden' }}>*</span>
                </Grid>
                : null
      }

      

      {
              isEditable(TEMPLATE_APP.FLASH_INFO_DESCRIPTION) ?
                <div className="comments">
                  <CustomInput field={TEMPLATE_APP.FLASH_INFO_DESCRIPTION} placeholder="Comments" updateValue={updateValue} getValue={getValue}></CustomInput>
                </div>
                :
                <Box> {usecaseComments ?
                  <Flashbar items={
                    flashBarComments
                  } /> : <Box></Box>
                }
                </Box>
            }
            {usecaseDevComments ?
              <Flashbar items={
                flashBarDevComments
              } /> :
              ''}
      
    </SpaceBetween>
  )

  const friscoAnnotation = (
    <SpaceBetween direction="vertical" size="m">
      <Modal
        onDismiss={() => { setShowAnnotationImportModal(false); resetAnnotationModalView() }}
        visible={showAnnotationImportModal}
        header="Upload"
        size="large"
      >

        <Grid
          gridDefinition={[{ colspan: 5 }, { colspan: 7 }]}
        >
          <SpaceBetween direction="vertical" size="s">
            {annotationUploadLoader ? <Box><Spinner></Spinner> uploading input file..</Box> : ''}
            <SpaceBetween direction="horizontal">
              <FileUpload
                onChange={({ detail }) => {
                  setAnnotationInputFile(detail.value);
                }}
                value={annotationInputFile}
                i18nStrings={{
                  uploadButtonText: e =>
                    e ? "Choose files" : "Choose file",
                  dropzoneText: e =>
                    e
                      ? "Drop files to generate"
                      : "Drop file to generate",
                  removeFileAriaLabel: e =>
                    `Remove file ${e + 1}`,
                  limitShowFewer: "Show fewer files",
                  limitShowMore: "Show more files",
                  errorIconAriaLabel: "Error"
                }}
                showFileLastModified
                showFileSize
                showFileThumbnail
                tokenLimit={1}
                accept=".csv"
                constraintText="upload input file"
              />

              {
                annotationInputFile && annotationInputFile?.length > 0 ? <Button variant="primary" disabled={annotationUploadLoader} onClick={uploadAnnotationInput}>Upload</Button> : ''
              }

            </SpaceBetween>

            <SpaceBetween direction="vertical" size="s">
              {annotationColumns?.map((column) => {
                return <StatusIndicator>{column}</StatusIndicator>
              })}
            </SpaceBetween>
          </SpaceBetween>
          <Container>
            <SpaceBetween direction="vertical">
              <Box>The file should contain the following columns in below order</Box>
              <Box>
                {validationColumns.map((column) => {
                  return <li>{column}</li>
                })}
              </Box>
            </SpaceBetween>
          </Container>
        </Grid>

      </Modal>

      <Modal
        onDismiss={() => { setShowAnnotationImportAppendModal(false); resetAnnotationModalView() }}
        visible={showAnnotationImportAppendModal}
        header="Upload"
        size="large"
      >

        <Grid
          gridDefinition={[{ colspan: 5 }, { colspan: 7 }]}
        >
          <SpaceBetween direction="vertical" size="s">
            {annotationUploadLoader ? <Box><Spinner></Spinner> Loading input file..</Box> : ''}
            <SpaceBetween direction="horizontal">
              <FileUpload
                onChange={({ detail }) => {
                  setAnnotationInputFile(detail.value);
                }}
                value={annotationInputFile}
                i18nStrings={{
                  uploadButtonText: e =>
                    e ? "Choose files" : "Choose file",
                  dropzoneText: e =>
                    e
                      ? "Drop files to generate"
                      : "Drop file to generate",
                  removeFileAriaLabel: e =>
                    `Remove file ${e + 1}`,
                  limitShowFewer: "Show fewer files",
                  limitShowMore: "Show more files",
                  errorIconAriaLabel: "Error"
                }}
                showFileLastModified
                showFileSize
                showFileThumbnail
                tokenLimit={1}
                accept=".csv"
                constraintText="upload input file"
              />

              {
                annotationInputFile && annotationInputFile?.length > 0 ? <Button variant="primary" disabled={annotationUploadLoader} onClick={() => { uploadAnnotationAppendInput() }}>Upload</Button> : ''
              }

            </SpaceBetween>

            <SpaceBetween direction="vertical" size="s">
              {
                annotationInputFile && annotationInputFile?.length > 0 && annotationColumns && annotationColumns?.length > 0 ? <>
                  {
                    dsInfo?.columns ? <>
                      {dsInfo?.columns?.map((column, index) => {
                        if (column == annotationColumns[index]) {
                          return <StatusIndicator>{column}</StatusIndicator>
                        } else {
                          return <StatusIndicator type='error'>{dsInfo.columns[index]}</StatusIndicator>
                        }
                      })}
                    </> : <>
                      {annotationColumns?.map((column, index) => {
                        return <StatusIndicator>{column}</StatusIndicator>
                      })}
                    </>
                  }
                </> : <></>

              }
              {annotationColumns?.map((column, index) => {
                if (dsInfo?.columns?.[index]) {
                  if (column == dsInfo.columns[index]) {
                    return <StatusIndicator>{column}</StatusIndicator>
                  } else {
                    return <StatusIndicator type='error'>{dsInfo.columns[index]}</StatusIndicator>
                  }
                } else {
                  return <StatusIndicator>{column}</StatusIndicator>
                }


              })}
            </SpaceBetween>
          </SpaceBetween>
          <Container>
            <SpaceBetween direction="vertical">
              <Box>The file should contain the following columns in below order</Box>
              <Box>
                {validationColumns.map((column) => {
                  return <li>{column}</li>
                })}
              </Box>
            </SpaceBetween>
          </Container>
        </Grid>

      </Modal>
      <Container disableContentPaddings={false} disableHeaderPaddings={true}>
        <SpaceBetween direction="vertical">
          <Grid
            gridDefinition={[
              { colspan: { default: 3, xxs: 3 } },
              { colspan: { default: 9, xxs: 9 } }
            ]}
          >
            <Box padding="m">
              <SpaceBetween direction="horizontal" size="xs">
                {annotationLoader ? <Box> <Spinner></Spinner>{annotationLoader}</Box> : <></>}
                {annotationError ? <Box> <span className="error_message">{annotationError}</span> </Box> : <></>}
                {
                  (!(undoEditCount <= 0 || rowGroupColumns?.length > 0)) ? <Box><StatusIndicator type="warning">Attention: You have unsaved work</StatusIndicator></Box> : ''
                }
                {
                  annotationSaveSuccessMessage ? <StatusIndicator type="success">{annotationSaveSuccessMessage}</StatusIndicator> : ''
                }
              </SpaceBetween>
            </Box>
            <Box float="right" padding="m">
              <SpaceBetween direction="horizontal" size="xl">
                {/* <Button variant="icon" iconName="undo" onClick={(()=>undo())}></Button>
      <Button variant="icon" iconName="redo" onClick={(()=>redo())}></Button> */}

                <Button onClick={(() => saveAnnotated())} disabled={undoEditCount <= 0 || rowGroupColumns?.length > 0}>Save</Button>
                <ButtonDropdown
                  items={[
                    {
                      text: "Export to excel",
                      items: [
                        { text: "Current view", id: "current_view", disabled: false },
                        { text: "Selected rows", id: "selected_rows", disabled: false },
                        { text: "Original", id: "original", disabled: false }
                      ]
                    },
                    {
                      text: "Import",
                      items: [
                        { text: "Upload from excel", id: "import_csv", disabled: false },
                        { text: "Add additional data from excel", id: "import_csv_append", disabled: false }
                      ]
                    }
                  ]}
                  onItemClick={(event) => {
                    if (event.detail.id == 'current_view') {
                      exportAnnotated({ 'filtered': true })
                    } else if (event.detail.id == 'selected_rows') {
                      exportAnnotated({ 'selectedOnly': true })
                    }
                    else if (event.detail.id == 'original') {
                      exportAnnotated()
                    } else if (event.detail.id == 'import_csv') {
                      setShowAnnotationImportModal(true)
                    } else if (event.detail.id == 'import_csv_append') {
                      setShowAnnotationImportAppendModal(true)
                    }
                  }}
                >
                  Actions
                </ButtonDropdown>
                <Button onClick={(() => addRowToAnnotation())} iconName="insert-row">Add</Button>
                <Button onClick={(() => delRowToAnnotation())} disabled={multiSelectedRow?.length <= 0} iconName="delete-marker">Delete</Button>
                {/* <Button variant="icon" iconName="unlocked" onClick={(()=>handleViewChanges())}></Button> */}
                <Button variant="icon" iconName="refresh" onClick={(() => getAnnotationInput())}></Button>
              </SpaceBetween>
            </Box>
          </Grid>
          <div style={{
            width: '100%',
            height: 'calc(100vh - 200px)',
          }}>
            <div
              className="ag-theme-alpine"
              style={{
                width: '100%',
                height: '100%',
                minHeight: '500px'
              }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={dsInfo}
                defaultColDef={defaultProjectColDef}
                columnDefs={columnsList}
                rowSelection='multiple'
                onSelectionChanged={onSelectionChanged}
                suppressRowClickSelection={true}
                rowMultiSelectWithClick={true}
                rowNumbers={true}
                // editType={"fullRow"}
                animateRows={true}
                rowHeight={30}
                enableCellTextSelection={false}
                stopEditingWhenCellsLoseFocus={true}
                undoRedoCellEditing={true}
                undoRedoCellEditingLimit={10}
                onCellValueChanged={onCellValueChanged}
                onCellFocused={onCellFocused}
                onGridReady={onGridReady}
                onColumnRowGroupChanged={onColumnRowGroupChanged}
                rowGroupPanelShow="always"
                sideBar={sideBar}
                // groupTotalRow="bottom"
                groupAggFiltering={false}
                pivotMode={false}
                suppressAggFuncInHeader={false}
                enableCellSelection={true}
                enableRangeSelection={true}
                onRangeSelectionChanged={onRangeSelectionChanged}
                getContextMenuItems={getContextMenuItems}
                enableContextMenu={true}
                // onModelUpdated={onModelUpdated}
                onFilterChanged={onFilterChanged}
                onViewportChanged={onViewportChanged}
                suppressMenuHide={true}
                suppressScrollOnNewData={true}
                ensureDomOrder={true}
              />
              {
                aggregationValues && aggregationValues?.count > 1 ?
                  <Box float="right">
                    <SpaceBetween direction="horizontal" size="s">
                      <Box><span className="agg-text bold-text">Average:</span> <span className="agg-text">{aggregationValues.average}</span></Box>
                      <Box><span className="agg-text bold-text">Count:</span> <span className="agg-text">{aggregationValues.count}</span></Box>
                      <Box><span className="agg-text bold-text">Min:</span> <span className="agg-text">{aggregationValues.min}</span></Box>
                      <Box><span className="agg-text bold-text">Max:</span> <span className="agg-text">{aggregationValues.max}</span></Box>
                      <Box><span className="agg-text bold-text">Sum:</span> <span className="agg-text">{aggregationValues.sum}</span></Box>
                    </SpaceBetween>
                  </Box>
                  : ''
              }
              {
                gridInfo ? <Box float="left">
                  <SpaceBetween direction="horizontal" size="s">
                    <Box><span className="agg-text bold-text">Filtered rows:</span> <span className="agg-text">{gridInfo.rowCount}</span></Box>
                    <Box><span className="agg-text bold-text">Total rows:</span> <span className="agg-text">{gridInfo.totalRows}</span></Box>
                  </SpaceBetween>
                </Box> : ''
              }
            </div>
          </div>
        </SpaceBetween>

      </Container>
    </SpaceBetween>


  )

  const reports = (
    <SpaceBetween direction="vertical">
      <Tabs
        onChange={({ detail }) =>
          setActiveReportTabId(detail.activeTabId)
        }
        activeTabId={activeReportTabId}
        tabs={quicksightReports}
        disableContentPaddings={true}
      />
      {
        embedUrlLoadingMessage ?
          <Box><br></br> <Spinner></Spinner>  {embedUrlLoadingMessage} <br></br></Box> : <></>
      }
      {
        embedUrl ?
          <div>
            <Box padding="xs">
              <span className="agg-text bold-text">AWS Account:</span> <span className="agg-text" title={currentStage || 'N/A'}>{(awsAccount) || 'N/A'}</span>
            </Box>
            <iframe
              className="qs_dash"
              src={embedUrl}>
            </iframe>
          </div> : <></>
      }
    </SpaceBetween>
  )

  const Content = (
    <>
      {showLoadingIcon ? (
        <Modal visible={showLoadingIcon}>
          <Box>
            <Spinner></Spinner>
            Loading...
          </Box>
        </Modal>
      ) : (<Box
      >
        <div className="app_header custom-home__header">
          {appHeader}
        </div>
        <div class="app_details">
          <Box padding={{ bottom: "xxs" }}>
            <MenuBar
              onTabChange={handleMenuChange}
              activeTab={activeTabId}
              activeSubTab={activeSubTabId}
              isEditMode={isEditMode}
              shouldNotShowResults={shouldNotShowResults}
            />
          </Box>
          {activeTabId === 'details' && !isEditable(TEMPLATE_APP.APP_DESCRIPTION) && usecaseDescription && (
            <>
              
                <Box variant="h1" margin = "xs">About this Application</Box>
             
              <Box padding={{ bottom: "xxs" }}>
                <Container>
                  <Box variant="p" padding = "xxs">{usecaseDescription}</Box>
                </Container>
              </Box>
            </>
          )}
          {activeTabId === 'actions' && (
            <Box padding={{ bottom: "n" }}>
              <Container disableContentPaddings={true}>
                <Box padding="m">
                  <div className="page-description-container">
                    {editingPageDescriptionTab === 'actions' ? (
                      <>
                        <div className="page-description-input">
                          <Input
                            value={pageDescriptionDraft}
                            placeholder={DEFAULT_PAGE_DESCRIPTIONS.actions}
                            onChange={({ detail }) => setPageDescriptionDraft(detail.value)}
                            onKeyDown={({ detail }) => {
                              if (detail.key === 'Escape') {
                                setEditingPageDescriptionTab(null);
                              }
                            }}
                            autoFocus
                          />
                        </div>
                        <Button
                          variant="icon"
                          iconName="check"
                          onClick={() => savePageDescription('actions', pageDescriptionDraft)}
                          ariaLabel="Save description"
                        />
                        <Button
                          variant="icon"
                          iconName="close"
                          onClick={() => setEditingPageDescriptionTab(null)}
                          ariaLabel="Cancel editing"
                        />
                      </>
                    ) : (
                      <>
                        <span className="page-description-text">{pageDescriptions.actions || DEFAULT_PAGE_DESCRIPTIONS.actions}</span>
                        {(canEdit || isSupportAdmin) && (
                          <Button
                            variant="icon"
                            iconName="edit"
                            onClick={() => { setPageDescriptionDraft(pageDescriptions.actions || ''); setEditingPageDescriptionTab('actions'); }}
                            ariaLabel="Edit description"
                          />
                        )}
                      </>
                    )}
                  </div>
                </Box>
              </Container>
            </Box>
          )}
          {activeTabId === 'actions' && (
            <Container className={`actions-content`}>
                {
                  <BannerContainer displayLocations={[BannerDisplayLocation.Microservice]} roundedCorners={true} parameters={{microserviceAction:activeSubTabId, microserviceId:selectedSidebarItemId}} />
                }
                <Grid gridDefinition={[{ colspan: 11 }, { colspan: 1 }]}>
                {isLoadingActionTabs ? (
                  <Box padding="s">
                    <Spinner size="normal" /> Loading tabs...
                  </Box>
                ) : (
                  <Tabs
                    onChange={({ detail }) => {
                      handleMenuChange(activeTabId, detail.activeTabId);
                    }}
                    activeTabId={activeSubTabId}
                    tabs={getDynamicActionTabs()}
                  />
                )}
                <Box float="right">
                  {isSupportAdmin && !isEditMode && !isLoadingActionTabs && (
                    <Button
                      variant="icon"
                      iconName="settings"
                      onClick={() => setShowActionTabsSettings(true)}
                      ariaLabel="Customize Action Tabs (ateam-bi only)"
                    />
                  )}
                </Box>
              </Grid>
              <Box padding={{ top: "xxs" }}>
                {(activeSubTabId === DEFAULT_SCHEDULER_TAB.id) ? (
                  // Full-width layout for Scheduler (no sidebar)
                  <Container>
                    <ProcessContentRenderer
                      activeSubTabId={activeSubTabId}
                      activeProcessTab={activeProcessTab}
                      selectedSidebarItemId={selectedSidebarItemId}
                      id={id}
                      location={location}
                      flexicoTemplates={flexicoTemplates}
                      logicoProcesses={logicoProcesses}
                      subProcesses={subProcesses}
                      friscoProcessTabs={friscoProcessTabs}
                      disableAppLayout={true}
                      selectedSidebarContent={selectedSidebarContent}
                      metaData={dataFromMeta}
                    />
                  </Container>
                ) : (
                  // Layout with sidebar for other action tabs
                  <Grid gridDefinition={
                    NavOpen 
                      ? [{ colspan: 2 }, { colspan: 10 }]
                      : [{ colspan: 12 }]
                  }>
                    <ProcessSidebar
                      isOpen={NavOpen}
                      onToggle={() => setNavOpen(!NavOpen)}
                      activeSubTabId={activeSubTabId}
                      flexicoTemplates={flexicoTemplates}
                      subProcesses={subProcesses}
                      logicoProcesses={logicoProcesses}
                      selectedSidebarItemId={selectedSidebarItemId}
                      onProcessSelect={handleProcessSelect}
                      canEdit={canEdit}
                      onAddNew={handleAddNewProcess}
                      id={id}
                    />
                    <Container>
                      <ProcessContentRenderer
                        activeSubTabId={activeSubTabId}
                        activeProcessTab={activeProcessTab}
                        selectedSidebarItemId={selectedSidebarItemId}
                        id={id}
                        location={location}
                        flexicoTemplates={flexicoTemplates}
                        logicoProcesses={logicoProcesses}
                        subProcesses={subProcesses}
                        friscoProcessTabs={friscoProcessTabs}
                        disableAppLayout={true}
                        selectedSidebarContent={selectedSidebarContent}
                        metaData={dataFromMeta}
                      />
                      {!selectedSidebarItemId && (
                        <Box padding="l">
                          <Box variant="h3">Select a Process</Box>
                          <Box variant="p">Choose a process from the sidebar to get started with your automation tasks.</Box>
                        </Box>
                      )}
                    </Container>
                  </Grid>
                )}
              </Box>
            </Container>
          )}
          {activeTabId !== 'actions' && (
            <div className="main-content">
              {activeTabId === 'details' && appDetails}
              {activeTabId === 'results' && reports}
              {activeTabId === 'approvals' && (
                <ApprovalsHome id={id} />
              )}
              {activeTabId === 'audit' && (
                <AppAuditLogging id={id} />
              )}
            </div>
          )}
        </div>


        {/* Action Tabs Settings Modal */}
        <ActionTabsSettingsModal
          visible={showActionTabsSettings}
          onDismiss={() => setShowActionTabsSettings(false)}
          currentConfiguration={actionTabsConfiguration}
         
          onConfigUpdated={loadActionTabsConfiguration}
          appName={usecaseName}
          appId={id}
        />

      </Box>)
      }

    </>
  )

  const helpContent = (
    <HelpPanel header={<Box variant="h2">Glossary</Box>}>
      <Box>
        <ul>
          {glossary.map((item) => (
            <li key={item.label} className="list-item-data">
              <ExpandableSection
                variant="navigation"
                headerText={item.label}
              >
                {item.description}
              </ExpandableSection>
            </li>
          ))}
        </ul>
      </Box>
    </HelpPanel>
  );

  const inIframe = window.self !== window.top;
  const hideNavForIframe = inIframe && !props?.sideNavTitle;

  return (
    <AppLayout
      disableContentPaddings={true}
      content={Content}
      navigationHide={hideNavForIframe || (props?.hideSideNav != null ? props.hideSideNav : false)}
      navigationOpen={!hideNavForIframe && appNavOpen}
      onNavigationChange={({ detail }) => setAppNavOpen(detail.open)}
      contentType="default"
      toolsHide={true}
      headerSelector="#h"
      maxContentWidth={Number.MAX_VALUE}
      navigation={hideNavForIframe ? undefined : (props?.sideNavTitle ? <SideNav activeHref={`/App/${id}`} id={id} applicationName={props.sideNavTitle} customSideNavitems={customSideNavitems} /> : <HomeSideNav activeHref={`/App/${id}`} appName={usecaseName} appHref={`/App/${id}`} />)}
    />
  );
};
